import { moduleNames } from "data/enums/modules";
import {
  enumPermissionModules as EPM,
  enumPermissions as EP,
} from "../enums/authorization";

const enumTranslations = {
  offersPayouts: {
    users: 'Пользователи',
    offers: 'Офферы'
  },
  usersType: {
    1: "Внутренний",
    2: "Внешний",
    default: "Неизвестно",
  },
  trafficType: {
    1: "Фейсбук",
    2: "Гугл",
    3: "Нативная",
    4: "Пуш",
    5: "Другое",
    default: "Неизвестно",
  },
  booleanEnum: {
    true: "Да",
    false: "Нет",
    default: "Нет",
  },
  booleanYesNo: {
    default: "Нет",
    yes: "Да",
    no: "Нет",
  },
  changeLogChangeGroup: {
    1: "Общее",
    2: "Администратор",
    3: "Партнер",
    4: "Рекламодатель",
    default: "Неизвестно",
  },
  changeLogType: {
    1: "Улучшение",
    2: "Исправление ошибки",
    3: "Новая функция",
    default: "Неизвестно",
  },
  domainsStatus: {
    1: "Активен",
    2: "Тестовый режим",
    3: "Неактивен",
    4: "Приостановлен",
    default: "Н/Д",
  },

  domainsType: {
    1: "Отслеживание",
    default: "Н/Д",
  },
  status: {
    1: "Успех",
    2: "Ошибка",
    default: "Н/Д",
  },
  device: {
    desktop: "Настольный компьютер",
    mobile: "Мобильный",
    tablet: "Планшет",
    default: "Н/Д",
  },
  boolean: {
    default: "Нет",
    true: "Да",
    false: "Нет",
  },
  offersStatus: {
    1: "Активно",
    2: "Режим тестирования",
    3: "Неактивно",
    4: "Приостановлено",
    default: "Н/Д",
  },
  offersType: {
    "fixed-amount": "Фиксированная сумма",
    "percentage": "Процент",
    default: "N/A"
  },
  offersLimitType: {
    default: "Н/Д",
    "daily": "Ежедневно",
    "weekly": "Еженедельно",
    "hourly": "Почасово",
    "unlimited": "Без ограничений",
  },
  subscriptionsStatus: {
    1: "Активный",
    2: "Приостановлен",
    3: "Истёкший",
    9: "Удалён",
    default: "Н/Д",
  },
  subsDescription: {
    subscription: "Подписка",
    paid_content: "Платный контент",
    default: "Не применимо",
  },

  subscriptionsParts: {
    1: "Удержано",
    2: "Оплачено"
  },
  usersStatus: {
    1: "Администратор",
    2: "Менеджер аккаунтов",
    3: "Рекламодатель",
    4: "Партнёр",
    5: "Поддержка",
    6: "Финансы",
    99: "Заблокирован",
    default: "Неизвестно",
  },
  offersAccess: {
    regular: "Обычный",
    vip: "VIP",
    test: "Тестовый",
    private: "Приватный",
    dev: "Разработка",
    default: "Н/Д",
  },
  offersPaidStatus: {
    1: "Сохранено от партнера",
    2: "Отправлено рекламодателю",
    3: "В ожидании",
    4: "Подтверждено",
    5: "Отменено",
    6: "Удалено",
    7: "Неизвестно",
    8: "Подтвержден выкуп",
    9: "Ожидание выкупа",
    10: "Отклонен выкуп",
    default: "Н/Д",
  },
  offersPaidStatusLimited: {
    3: "В ожидании",
    4: "Подтверждено",
    default: "Н/Д",
  },
  offersDeviceType: {
    1: "Мобильное",
    2: "Настольное",
    default: "Н/Д",
  },
  offersCategory: {
    1: "Лидогенерация",
    2: "eCommerce",
    3: "Мобильный контент",
    4: "Установка приложений",
    default: "Н/Д",
  },
  offersVertical1: {
    1: "Программное обеспечение",
    2: "Казино",
    3: "Форекс",
    4: "Знакомства",
    5: "Розыгрыши",
    6: "Финансы/Займы",
    7: "Игры",
    8: "Социальные сети",
    9: "Покупки",
    10: "Развлечения",
    11: "Умная ссылка",
    12: "Криптовалюта",
    13: "Ставки",
    14: "Камеры",
    15: "Лотереи",
    16: "Бинарные опционы",
    default: "Н/Д",
  },

  offersFlow1: {
    1: 'SOI',
    2: 'DOI',
    3: 'IVR',
    4: 'CPS',
    5: 'Гибрид',
    default: "Н/Д",
  },


  offersVertical2: {
    default: "Н/Д",
    1: 'Секс-игрушки',
    2: 'Грибок',
    3: 'Корректоры',
    4: 'Холестерин',
    5: 'Здоровье и красота',
    6: 'Волосы',
    7: 'Иммунитет',
    8: 'Простатит',
    9: 'Зрение',
    10: 'Гипертония',
    11: 'Увеличение груди',
    12: 'Кости',
    13: 'Мышцы',
    14: 'Диабет',
    15: 'Кожный иммунитет',
    16: 'Фертильность',
    17: 'Красота',
    18: 'Акне',
    19: 'Суставы',
    20: 'Продукты для здоровья',
    21: 'Потенция',
    22: 'Аксессуары',
    23: 'Кухня',
    24: 'Дом и сад',
    25: 'Видеоигры',
    26: 'Детские игрушки',
    27: 'Геморрой',
    28: '>Похудение',
    29: 'Варикоз',
    30: '> Паразиты',
    31: 'CBD',
    32: 'Цистит',
    33: '>Целлюлит',
    34: 'Мужское увеличение',
    35: 'Зрение',
    36: 'Легкие',
    37: '>Усилители мозговой деятельности',
    38: 'Зубы',
    39: 'Эзотерика',
    40: 'Псориаз',
    41: 'Удаление волос',
    42: 'Храп',
    43: '>Печень',
    44: 'Зависимость от курения',
    45: 'Алкогольная зависимость',
    46: 'Гастрит',
    47: 'Женское либидо',
    48: "почка",
    49: "Взрослые развлечения",
    50: "Слух",
    51: "Морщины",
    52: "Антивозрастной",
    53: "Нейропатия"
  },

  offersFlow2: {
    1: "CPL",
    2: "COD",
    3: "CPS",
    4: "Доля от дохода",
    default: "Н/Д",
  },
  offersVertical3: {
    1: "Видео по требованию",
    2: "Игры",
    3: "Антивирусы/Безопасность",
    4: "Общее скачивание",
    5: "Знакомства",
    default: "Н/Д",
  },
  offersFlow3: {
    1: "Pin Submit",
    2: "DCB - Другое",
    3: "DCB - 1-клик",
    default: "Н/Д",
  },
  offersVertical4: {
    1: "Покупки",
    2: "Игры",
    3: "Путешествия",
    4: "Казино",
    default: "Н/Д",
  },
  offersFlow4: {
    1: "Установить и открыть",
    2: "Регистрация",
    3: "Продажа",
    default: "Н/Д",
  },
  offersFavorite: {
    true: "Избранное",
    false: "Не избранное",
    default: "Не избранное",
  },
  offersAccessStatus: {
    1: "В ожидании",
    2: "Подтверждено",
    3: "Отклонено",
    default: "Н/Д",
  },
  offerPayoutsTable: {
    offers: "Офферы",
    users: "Пользователи",
    default: "Н/Д",
  },
  guaranteesLogsTable: {
    user: "Пользователь",
    offer: "Оффер",
  },
  reportsVertical: {
    default: "Н/Д",
    'Sex Toys': 'Секс-игрушки',
    'Fungus': 'Грибок',
    'Correctors': 'Корректоры',
    'Cholesterol': 'Холестерин',
    'Health & Beauty': 'Здоровье и красота',
    'Hair': 'Волосы',
    'Immunity': 'Иммунитет',
    'Prostatitis': 'Простатит',
    'Eyesight': 'Зрение',
    'Hypertension': 'Гипертония',
    'Breast Enlargement': 'Увеличение груди',
    'Bones': 'Кости',
    'Muscle': 'Мышцы',
    'Diabetes': 'Диабет',
    'Skin Immunity': 'Иммунитет кожи',
    'Fertility Problems': 'Проблемы с фертильностью',
    'Beauty': 'Красота',
    'Acne': 'Акне',
    'Joints': 'Суставы',
    'Health Products': 'Продукты для здоровья',
    'Potency': 'Потенция',
    'Accessories': 'Аксессуары',
    'Kitchen': 'Кухня',
    'Home & Garden': 'Дом и сад',
    'Video Games': 'Видеоигры',
    'Kids Toys': 'Игрушки для детей',
    'Hemorrhoids': 'Геморрой',
    'Weight Loss': 'Похудение',
    'Varicose': 'Варикоз',
    'Parasites': 'Паразиты',
    'CBD': 'КБД',
    'Cystitis': 'Цистит',
    'Cellulite': 'Целлюлит',
    'Male Enlargement': 'Увеличение члена',
    'Vision': 'Зрение',
    'Lungs': 'Лёгкие',
    'Brain boosters': 'Стимуляторы мозга',
    'Teeth': 'Зубы',
    'Esoteric': 'Эзотерика',
    'Psoriasis': 'Псориаз',
    'Hair removal': 'Удаление волос',
    'Snoring': 'Храп',
    'Liver': 'Печень',
    'Smoking addiction': 'Никотиновая зависимость',
    'Alcohol addiction': 'Алкогольная зависимость',
    'Gastritis': 'Гастрит',
    'Female Libido': 'Женское либидо',
    'Kidney': 'Почки',
    'Adult Entertainment': 'Развлечения для взрослых',
    'Hearing': 'Слух',
    'Wrinkles': 'Морщины',
    'Anti-Age': 'Антивозрастное',
    'Neuropathy': 'Нейропатия',
  },
  reportsCategory: {
    default: "Н/Д",
    "Leadgen": "Лидогенерация",
    "eCommerce": "Электронная коммерция",
    "Mobile Content": "Мобильный контент",
    "App Installs": "Установки приложений",
  },

  usersGUaranteesStatus: {
    inactive: "Неактивно",
    active: "Активно",
    default: "Н/Д",
  },
  trackingLinksStatus: {
    1: "Активный",
    2: "Приостановлен",
    3: "Неизвестно",
    9: "Удалён",
  },
  prelandingsCategory: {
    1: "Тестовая категория",
    default: "Н/Д",
  },
  prelandingStatus: {
    1: "Активно",
    2: "Неактивно",
    default: "Н/Д",
  },
  prelandingsStatus: {
    1: "Активный",
    2: "Неактивный",
    3: "Н/Д",
  },
  landingStatus: {
    1: "Активно",
    2: "Неактивно",
    default: "Н/Д",
  },
  landingCategory: {
    1: "Тестовая категория",
    default: "Н/Д",
  },
  paymentsMethod: {
    default: "N/A",
    wire: "Банковский перевод",
    paypal: "PayPal",
    tipalti: "Tipalti",
    "usdt-erc20": "USDT ERC20",
    "usdt-trc20": "USDT TRC20",
    webmoney: "WebMoney",
    // "capitalist-internal": "Внутренний платеж Capitalist",
  },
  paymentsStatus: {
    1: "Создано",
    2: "Подтверждено",
    3: "Отклонено",
    4: "Оплачено",
    5: "Возвращено",
    default: "Н/Д",
  },
  paymentSettings: {
    active: "Активно",
    inactive: "Неактивно",
    default: "Н/Д",
    suspended: "Приостановлено",
  },
  paymentSettingsAddStatus: {
    active: "Активно",
    inactive: "Неактивно",
    default: "Н/Д",
  },
  ordersStatus: {
    1: "Сохранено от партнера",
    2: "Отправлено рекламодателю",
    3: "В ожидании",
    4: "Подтверждено",
    5: "Отменено",
    6: "Удалено",
    7: "Неизвестно",
    8: "Подтвержден выкуп",
    9: "Ожидание выкупа",
    10: "Отклонен выкуп",
    11: "Ошибка",
    default: "Н/Д",
  },
  guaranteesLogsStatus: {
    "hold": "На удержании",
    "confirmed": "Подтверждено",
    "cancelled": "Отменено",
    "trash": "Корзина",
    "unknown": "Неизвестно",
    default: "Н/Д",
  },

  orderStatusLimited: {
    1: "Сохранено от партнера",
    2: "Отправлено рекламодателю",
    3: "В ожидании",
    4: "Подтверждено",
    5: "Отменено",
    6: "Удалено",
    7: "Неизвестно",
    default: "Н/Д",
  },

  loginHistoryStatus: {
    1: "Успех",
    2: "Ошибка",
    default: "Н/Д",
  },

  loginHistoryDevice: {
    desktop: "Настольный компьютер",
    mobile: "Мобильный",
    tablet: "Планшет",
    default: "Н/Д",
  },
  ordersErrorsStatus: {
    default: "Н/Д",
    not_resolved: "Не решено",
    resolved: "Решено",
  },
  logsQueueEmailStatus: {
    default: "Н/Д",
    0: "Ожидание обработки",
    1: "Выполнено",
    2: "Ошибка",
  },
  postbackStatus: {
    default: "Н/Д",
    1: "Активно",
    2: "Неактивно",
  },
  postbackType: {
    default: "Н/Д",
    1: "Лид",
    2: "Событие",
  },
  postbackLevel: {
    default: "Н/Д",
    1: "Глобальный",
    2: "Специфический",
  },
  postbacksEventStandard: {
    default: "Н/Д",
    3: "В ожидании",
    4: "Подтверждено",
    5: "Отменено",
    6: "Удалено",
  },
  postbacksMethod: {
    default: "Н/Д",
    1: "S2S",
  },
  postbacksMethodTemp: {
    default: "Н/Д",
    1: "S2S",
  },
  postbackLogsStatus: {
    default: "Н/Д",
    success: "Успех",
    error: "Ошибка",
  },
  httpCodeStatus: {
    default: "Н/Д",
    0: "0 Ответ не получен",
    200: "200 OK",
    202: "202 Принято",
    203: "203 Неавторитетная информация",
    204: "204 Нет содержимого",
    205: "205 Сброс содержимого",
    206: "206 Частичное содержимое",
    300: "300 Множественный выбор",
    301: "301 Перемещено навсегда",
    302: "302 Найдено",
    303: "303 Смотреть другое",
    304: "304 Не изменено",
    307: "307 Временное перенаправление",
    308: "308 Постоянное перенаправление",
    400: "400 Плохой запрос",
    401: "401 Не авторизован",
    403: "403 Запрещено",
    405: "405 Метод не разрешен",
    406: "406 Неприемлемо",
    407: "407 Требуется аутентификация прокси",
    408: "408 Тайм-аут запроса",
    409: "409 Конфликт",
    410: "410 Ушел",
    411: "411 Требуется длина",
    412: "412 Нарушено предварительное условие",
    413: "412 Слишком большая нагрузка",
    414: "414 URI слишком длинный",
    415: "415 Неподдерживаемый тип носителя",
    416: "416 Диапазон не удовлетворяет",
    417: "417 Ожидание не выполнено",
    426: "426 Необходимо обновление",
    428: "428 Требуется предварительное условие",
    429: "429 Слишком много запросов",
    431: "431 Слишком большие поля заголовка запроса",
    500: "500 Внутренняя ошибка сервера",
    501: "501 Не реализовано",
    502: "502 Плохой шлюз",
    503: "503 Служба недоступна",
    504: "504 Время ожидания шлюза",
    505: "505 Версия HTTP не поддерживается",
    510: "510 Не расширено",
    511: "511 Требуется аутентификация сети",
  },
  statsBasedOn: {
    offer: "Офферы",
    date: "Дата",
    month: "Месяц",
    day_of_week: "День недели",
    time: "Время",
    hour_of_day: "Час дня",
    landings: "Посадочные страницы",
    prelandings: "Предварительные страницы",
    country_code: "Страна",
    sub_1: "Sub 1",
    sub_2: "Sub 2",
    sub_3: "Sub 3",
    sub_4: "Sub 4",
    utm_campaign: "UTM кампания",
    utm_source: "UTM источник",
    utm_medium: "UTM средство",
    utm_term: "UTM ключевое слово",
    utm_content: "UTM контент",
    device_type: "Тип устройства",
    browser_name: "Браузера",
    browser_version: "Версия браузера",
    os_name: "Имя ОС",
    os_version: "Версия ОС",
  },
  newsStatus: {
    default: "Н/Д",
    unpublished: "Неопубликованное",
    published: "Опубликованное",
    draft: "Черновик",
  },
  newsCategory: {
    default: "Н/Д",
    1: "Общее",
    2: "Выплаты",
    3: "Новые Офферы",
    4: "Новые гео",
    5: 'Предлагает СТОП',
    6: 'Предлагает Обновить',
    7: 'Специальное предложение'
  },
  newsAutomaticDeletionAfter: {
    default: "Н/Д",
    'never': "Никогда",
    86400: "1 день",
    604800: "1 неделя",
    1209600: "2 недели",
    2592000: "1 месяц",
  }
};

const commonTableFilters = {
  filter: "Фильтры",
  search: "Поиск фильтров",
  filterTypes: {
    dateRange: {
      label: "Диапазон дат",
      helperText: "Значение представляет собой дату сервера",
      invalidRange: ": неверный диапазон",
      maxDate: ": превышена максимальная дата",
      minDate: ": ниже минимальной даты",
    },
    selectStaticMultiple: {
      placeholder: "Выбрать",
      noOptionsText: "Нет доступных вариантов",
      select: "Выбрать",
      noCategory: "Пожалуйста, выберите категорию"
    },
    selectStaticSingle: {
      placeholder: "Выбрать",
      noOptionsText: "Нет доступных вариантов",
    },
    countrySelect: {
      placeholder: "Выбрать страну",
    },
    selectAjaxMultiple: {
      text: "Нет доступных вариантов",
      placeholder: "Поиск",
      loading: "Загрузка",
    },
  },
  sortAsc: "Сортировать по возрастанию",
  sortDesc: "Сортировать по убыванию",
  hideColumn: "Скрыть колонку",
  clearStickyColumn: "Снять закрепление колонки",
  setStickyColumn: "Закрепить колонку",
  clearStickyRow: "Снять закрепление строки",
  setStickyRow: "Закрепить строку",
  noData: "Нет данных",
  pinColumnLeft: "Закрепить колонку слева",
  pinColumnRight: "Закрепить колонку справа",
  unpinColumn: "Открепить колонку",
  toggleChartVisibility: "Переключить видимость графика",
  clearFilters: "Очистить фильтры",
  collapseFilters: "Свернуть фильтры",
  expandFilters: "Развернуть фильтры",
  tableView: "Просмотр таблицы",
  chartView: "Просмотр графика",
  saveFilters: 'Сохранить фильтры',
  saveFiltersAsBookmark: "Сохранить просмотры как закладки",
  pleaseEnterANameForBookmark: "Пожалуйста, введите название для закладки",
  cancel: "Отмена",
  save: "Сохранить",
  filtersSaved: "Фильтры сохранены!"
};

const commonModalTranslations = {
  saveView: "Сохранить вид",
  tabs: {
    required: "Обязательное*",
    affectedRows: "Затронутые строки",
    info: "Информация",
    target: "Цель",
    advertiser: "Рекламодатель",
    overrides: "Переопределения",
    newRecord: "Новая запись",
    payments: "Платежи",
    company: "Компания",
  },
  footer: {
    reset: "Сброс",
    cancel: "Отмена",
    submit: "Отправить",
    confirm: "Подтвердить",
    delete: "Удалить",
  },
  body: {
    warning: "Это действие нельзя отменить!",
    question: "Вы уверены, что хотите удалить ",
    approveQuestion: "Вы уверены, что хотите подтвердить оплату",
    noItems: "Нет выбранных элементов для массового удаления",
    noItemsAdd: "Не выбраны элементы для массового добавления",
    isLoading: "Удаление",
    isSuccess: "Успешно удалено",
    isError: "Ошибка при удалении",
    itemSelected: "Элемент выбран для массового удаления",
    itemSelectedEdit: "Элемент выбран для массового редактирования",
    sendingUpdate: "Отправка обновления",
    seccessfullyUpdated: "Успешно обновлено",
    isErrorEdit: "Ошибка при обновлении",
    required: "обязательное",
    name: {
      label: "Имя",
      placeholder: "Введите имя для параметра",
    },
    value: {
      label: "Значение",
      placeholder: "Введите значение для параметра",
    },
    deleteParam: "Удалить параметр",
  },
  filepond: {
    labelIdle:
      "Перетащите файлы сюда или <span class='filepond--label-action'> Выберите </span>",
    labelInvalidField: "Поле содержит недопустимые файлы",
    labelFileProcessing: "Загрузка",
    labelFileRemoveError: "Ошибка при удалении",
    labelFileLoadError: "Ошибка при загрузке",
    labelTapToCancel: "нажмите, чтобы отменить",
    labelFileProcessingComplete: "Загрузка завершена",
    labelFileProcessingAborted: "Загрузка отменена",
    labelButtonProcessItem: "Загрузить",
    labelButtonRetryItemProcessing: "Повторить",
    labelButtonAbortItemProcessing: "Отменить",
    labelButtonUndoItemProcessing: "Отменить",
    labelTapToUndo: "нажмите, чтобы отменить",
    labelFileLoading: "Загрузка",
  },
  formBuilder: {
    reset: 'Сбросить стили',
    generateUrl: 'Сгенерировать URL',
    generatedMessage: 'Сгенерированный URL',
    form: 'Форма',
    formCustomization: 'Выберите элемент',
    inputs: 'Поля ввода',
    inputsCustomization: 'Настройка полей ввода',
    text: 'Текст',
    priceTitle: 'Заголовок',
    oldPrice: 'Старая цена',
    price: 'Текущая цена',
    textAlign: 'Выровнять текст',
    flex: 'Направление компоновки',
    justifyContent: 'Выравнивание по горизонтали',
    alignItems: 'Выравнивание по вертикали',
    gap: 'Отступ',
    width: 'Ширина',
    backgroundColor: 'Цвет фона',
    borderWidth: 'Толщина границы',
    borderColor: 'Цвет границы',
    borderRadius: 'Радиус границы',
    fontSize: 'Размер шрифта',
    fontWeight: 'Начертание шрифта',
    light: 'Тонкий',
    normal: 'Обычный',
    bold: 'Жирный',
    padding: 'Внутренний отступ',
    margin: 'Внешний отступ',
    textColor: 'Цвет текста',
    enableCountry: 'Включить выбор страны',
    enableQuantity: 'Включить количество',
    namePlaceholder: 'Введите текст для поля имени',
    phonePlaceholder: 'Введите текст для поля телефона',
    countryPlaceholder: 'Введите текст для выбора страны',
    quantityPlaceholder: 'Введите текст для поля количества',
    enableMockup: 'Включить макет',
    enablePrice: 'Включить цену',
    quantityLeftPlaceholder: 'Напр. Осталось всего {quantity}',
    numberInputLabel: 'Количество',



  }

};

const profileServerFieldErrors = {
  8: {
    password: "Пароль должен содержать от 12 до 128 символов.",
    repeated_password: "Пароли не совпадают.",
    "info.pin": "PIN должен состоять ровно из 4 цифр.",
    "info.repeat_pin": "PIN-коды не совпадают.",
  },
};

const commonTableTranslations = {
  of: 'из',
  drawer: {
    savedFilterBookmarks: "Сохраненные виды",
    noBookmarksAdded: "Виды не добавлены",
    toAddAFiltersBookmark: "Чтобы добавить вид, нажмите 'Сохранить вид' ниже",
    saveCurrentView: "Сохранить текущий вид"
  },
  header: {
    filters: "Фильтры",
    sortAsc: "Сортировать по возрастанию",
    sortDesc: "Сортировать по убыванию",
    all: "Все",
    refreshData: "Обновить данные",
    columnsEditor: "Редактор столбцов",
    visualLayers: "Визуальные слои",
    emptySpace: "Заполнить пустое место в таблице",
    bulkOptions: "Массовые опции",
    orderColumns: "Выберите или переупорядочьте столбцы таблицы",
    enable: "Включить автозаполнение при изменении размера экрана",
    disable: "Отключить автозаполнение при изменении размера экрана",
    downloadTableData: "Скачать данные таблицы",
    tableView: "Табличный вид",
    chartView: "Вид диаграммы",
    emptySpaceOptions: {
      fillEmptySpace: "Заполнить пустое место",
      enableAutoFill: "Включить автозаполнение при изменении размера экрана",
      disableAutoFill: "Отключить автозаполнение при изменении размера экрана",
    },
    savedFilters: "Сохраненные просмотры",
    columnsSaved: "Столбцы сохранены!"
  },
  body: {
    pinRow: "Закрепить строку",
    cards: {
      created: "Создано",
      approved: "Одобрено",
      rejected: "Отклонено",
      paid: "Оплачено",
      return: "Возврат",
    },
    noData: "Нет данных",
  },
  modale: {
    columnsEditorTitle: "Выберите или измените порядок столбцов таблицы",
  },
};

const RU = {
  modalFieldsErrors: {
    required: "Обязательное",
    minimum: (minChar) => `минимум ${minChar} символов`,
    maximum: (maxChar) => `максимум ${maxChar} символов`,
    min: (min) => `минимально допустимое значение ${min}`,
    max: (max) => `максимально допустимое значение ${max}`,
    email: "неверный формат",
    domain: "неверный формат (http/https)://domain.com)",
    fieldsDontMatch: (matchFieldLabel) =>
      `поля не совпадают с ${matchFieldLabel}`,
  },
  MenuSegment: {
    admin: "Админ",
    affiliate: "Партнер",
    advertiser: "Рекламодатель",
    user: "Пользователь",
    system: "Система",
    dev: "Разработчик",
  },
  MenuLink: {
    [moduleNames.ADMIN_DASHBOARD]: "Дашборд",
    [moduleNames.ADMIN_REPORT_DROPDOWN]: "Отчеты",
    [moduleNames.ADMIN_REPORT_BALANCE]: "Баланс",
    [moduleNames.ADMIN_REPORT_OFFERS]: "Офферы",
    [moduleNames.ADMIN_REPORT_USERS]: "Пользователи",
    [moduleNames.ADMIN_REPORT_ADVERTISERS]: "Рекламодатели",
    [moduleNames.ADMIN_REPORT_COUNTRIES]: "Страны",
    [moduleNames.ADMIN_REPORT_DYNAMICS]: "Динамика",
    [moduleNames.ADMIN_REPORT_ORDERS]: "Заказы",
    [moduleNames.ADMIN_USERS_DROPDOWN]: "Пользователи",
    [moduleNames.ADMIN_USERS]: "Все пользователи",
    [moduleNames.ADMIN_USERS_UNAPPROVED]: "Неодобренные",
    [moduleNames.ADMIN_DOMAINS]: "Домены",
    [moduleNames.ADMIN_NEWS]: "Новости",
    [moduleNames.ADMIN_OFFERS_DROPDOWN]: "Офферы",
    [moduleNames.ADMIN_OFFERS_BLACKLIST_USERS]: "Пользователи блеклиста",
    [moduleNames.ADMIN_OFFERS]: "Список",
    [moduleNames.ADMIN_OFFERS_SUBSCRIPTIONS]: "Подписки",
    [moduleNames.ADMIN_OFFERS_ACCESS]: "Доступ",
    [moduleNames.ADMIN_OFFERS_PAYOUT_OFFERS]: "Выплаты",
    [moduleNames.ADMIN_OFFERS_USERS_GUARANTEES]: "Гарантии пользователей",
    [moduleNames.ADMIN_GUARANTEES_DROPDOWN]: "Гарантии",
    [moduleNames.ADMIN_GUARANTEES_LOGS]: "Логи",
    [moduleNames.ADMIN_OFFERS_TRACKING_LINKS]: "Ссылки для отслеживания",
    [moduleNames.ADMIN_PAGES_DROPDOWN]: "Страницы",
    [moduleNames.ADMIN_LANDINGS]: "Посадочные",
    [moduleNames.ADMIN_LOGIN_HISTORY]: "История сеансов",
    [moduleNames.ADMIN_BALANCE]: "Баланс",
    [moduleNames.ADMIN_LOGS_DROPDOWN]: "Логи",
    [moduleNames.ADMIN_LOGS_QUEUE_EMAIL]: "Очередь Email",
    [moduleNames.ADMIN_PRELANDINGS]: "Предварительные",
    [moduleNames.ADMIN_PAYMENTS]: "Платежи",
    [moduleNames.ADMIN_ORDERS_DROPDOWN]: "Лиды",
    [moduleNames.ADMIN_ORDERS]: "Список",
    [moduleNames.ADMIN_ORDERS_ERRORS]: "Ошибки",
    [moduleNames.ADMIN_TOPUPS]: "Пополнения",
    [moduleNames.ADMIN_POSTBACK_LOGS]: "Логи постбеков",
    [moduleNames.ADMIN_PROFILE]: "Профиль",
    [moduleNames.ADMIN_CHANGELOG]: "Журнал изменений",
    [moduleNames.ADMIN_FAQ]: 'Часто задаваемые вопросы',
    [`${moduleNames.DEV_BUILDER_DROPDOWN}_admin`]: "Конструктор",
    [`${moduleNames.DEV_BUILDER_MODULE}_admin`]: "Модуль",

    // Модули партнеров
    [moduleNames.AFFILIATE_DASHBOARD]: "Дашборд",
    [moduleNames.AFFILIATE_REPORT]: "Отчет",
    [moduleNames.AFFILIATE_DOMAINS]: "Домены",
    [moduleNames.AFFILIATE_OFFERS_DROPDOWN]: "Офферы",
    [moduleNames.AFFILIATE_OFFERS_ALL]: "Все",
    [moduleNames.AFFILIATE_OFFERS_HOT]: "Топ",
    [moduleNames.AFFILIATE_OFFERS_SUBSCRIPTIONS]: "Подписки",
    [moduleNames.AFFILIATE_LOGIN_HISTORY]: "История сеансов",
    [moduleNames.AFFILIATE_PROFILE]: "Профиль",
    [moduleNames.AFFILIATE_ORDERS_DROPDOWN]: "Лиды",
    [moduleNames.AFFILIATE_ORDERS]: "Список",
    [moduleNames.AFFILIATE_PAYMENTS]: "Платежи",
    [moduleNames.AFFILIATE_PAYMENTS_REQUEST]: "Запрос выплаты",
    [moduleNames.AFFILIATE_PAYMENTS_SETTINGS]: "Настройки",
    [moduleNames.AFFILIATE_BALANCE]: "Баланс",
    [moduleNames.AFFILIATE_REFERRAL]: "Реферальная программа",
    [moduleNames.AFFILIATE_POSTBACK_DROPDOWN]: "Постбеки",
    [moduleNames.AFFILIATE_POSTBACK]: "Настройки",
    [moduleNames.AFFILIATE_POSTBACK_LOGS]: "Логи постбеков",
    [moduleNames.AFFILIATE_FAQ]: 'Часто задаваемые вопросы',
    [`${moduleNames.DEV_BUILDER_DROPDOWN}_aff`]: "Конструктор",
    [`${moduleNames.DEV_BUILDER_MODULE}_aff`]: "Модуль",

    // Модули рекламодателей
    [moduleNames.ADVERTISER_DASHBOARD]: "Дашборд",
    [moduleNames.ADVERTISER_OFFERS]: "Офферы",
    [moduleNames.ADVERTISER_ORDERS]: "Лиды",
    [moduleNames.ADVERTISER_TOPUPS]: "Пополнения",
    [moduleNames.ADVERTISER_LOGIN_HISTORY]: "История сеансов",
    [moduleNames.ADVERTISER_PROFILE]: "Профиль",
    [moduleNames.ADVERTISER_FAQ]: 'Часто задаваемые вопросы',
    [`${moduleNames.DEV_BUILDER_DROPDOWN}_adv`]: "Конструктор",
    [`${moduleNames.DEV_BUILDER_MODULE}_adv`]: "Модуль",
  },
  PermissionsModalBody: {
    admin: "Администратор",
    // Администратор - Панель
    [EPM.ADMIN_DASHBOARD]: "Дашборд",
    [EP.ADMIN_DASHBOARD_ANALYTICS]: "Аналитика",
    // Администратор - Отчет
    [EPM.ADMIN_REPORT]: "Отчет",
    [EP.ADMIN_REPORT_BALANCE]: "Баланс",
    [EP.ADMIN_REPORT_OFFERS]: "Офферы",
    [EP.ADMIN_REPORT_USERS]: "Пользователи",
    [EP.ADMIN_REPORT_ADVERTISERS]: "Рекламодатели",
    [EP.ADMIN_REPORT_COUNTRIES]: "Страны",
    [EP.ADMIN_REPORT_DYNAMICS]: "Динамика",
    [EP.ADMIN_REPORT_ORDERS]: "Заказы",
    // Администратор - Пользователи
    [EPM.ADMIN_USERS]: "Пользователи",
    [EP.ADMIN_USERS_LIST]: "Список",
    [EP.ADMIN_USERS_GET]: "Получить",
    [EP.ADMIN_USERS_CREATE]: "Создать",
    [EP.ADMIN_USERS_UPDATE]: "Обновить",
    [EP.ADMIN_USERS_UPDATE_EMAIL]: "Обновить email",
    [EP.ADMIN_USERS_DELETE]: "Удалить",

    // Администратор - Разрешения
    [EPM.ADMIN_PERMISSIONS]: "Разрешения",
    [EP.ADMIN_PERMISSIONS_GET]: "Получить",
    [EP.ADMIN_PERMISSIONS_UPDATE]: "Обновить",
    // Администратор - Неодобренные пользователи
    [EPM.ADMIN_USERS_UNAPPROVED]: "Неодобренные пользователи",
    [EP.ADMIN_USERS_UNAPPROVED_LIST]: "Список",
    [EP.ADMIN_USERS_UNAPPROVED_APPROVED]: "Утвердить",
    [EP.ADMIN_USERS_UNAPPROVED_REJECT]: "Отклонить",
    [EP.ADMIN_USERS_UNAPPROVED_SET_MANAGER]: "Назначить менеджера",
    [EP.ADMIN_USERS_UNAPPROVED_RESET_MANAGER]: "Сбросить менеджера",
    [EP.ADMIN_USERS_UNAPPROVED_TOTAL]: "Всего",
    // Администратор - Предложения
    [EPM.ADMIN_OFFERS]: "Офферы",
    [EP.ADMIN_OFFERS_LIST]: "Список",
    [EP.ADMIN_OFFERS_GET]: "Получить",
    [EP.ADMIN_OFFERS_CREATE]: "Создать",
    [EP.ADMIN_OFFERS_UPDATE]: "Обновить",
    // Админ - Подписки на предложения
    [EPM.ADMIN_OFFERS_SUBSCRIPTIONS]: "Подписки",
    [EP.ADMIN_OFFERS_SUBSCRIPTIONS_LIST]: "Список",
    [EP.ADMIN_OFFERS_SUBSCRIPTIONS_GET]: "Получить",
    [EP.ADMIN_OFFERS_SUBSCRIPTIONS_UPDATE]: "Обновить",
    [EP.ADMIN_OFFERS_SUBSCRIPTIONS_APPROVE_PAYMENT]: "Одобрить",
    [EP.ADMIN_OFFERS_SUBSCRIPTIONS_TOTAL]: "Всего",
    // Администратор - Доступ к предложениям
    [EPM.ADMIN_OFFERS_ACCESS]: "Доступ к Офферы",
    [EP.ADMIN_OFFERS_ACCESS_LIST]: "Список",
    [EP.ADMIN_OFFERS_ACCESS_CREATE]: "Создать",
    [EP.ADMIN_OFFERS_ACCESS_APPROVED]: "Утвердить",
    [EP.ADMIN_OFFERS_ACCESS_REJECT]: "Отклонить",
    //Admin - Offers blacklist users
    [EPM.ADMIN_OFFERS_BLACKLIST_USERS]: "Пользователи черного списка офферов",
    [EP.ADMIN_OFFERS_BLACKLIST_USERS_LIST]: "Список",
    [EP.ADMIN_OFFERS_BLACKLIST_USERS_CREATE]: "Создать",
    [EP.ADMIN_OFFERS_BLACKLIST_USERS_DELETE]: "Удалить",
    // Администратор - Выплаты по предложениям
    [EPM.ADMIN_OFFERS_PAYOUT]: "Выплаты по Офферы",
    [EP.ADMIN_OFFERS_PAYOUT_LIST]: "Список",
    [EP.ADMIN_OFFERS_PAYOUT_GET]: "Получить",
    [EP.ADMIN_OFFERS_PAYOUT_CREATE]: "Создать",
    [EP.ADMIN_OFFERS_PAYOUT_UPDATE]: "Обновить",
    [EP.ADMIN_OFFERS_PAYOUT_DELETE]: "Удалить",
    // Администратор - Гарантии пользователей по предложениям
    [EPM.ADMIN_OFFERS_USERS_GUARANTEES]: "Гарантии пользователей по Офферы",
    [EP.ADMIN_OFFERS_USERS_GUARANTEES_LIST]: "Список",
    [EP.ADMIN_OFFERS_USERS_GUARANTEES_GET]: "Получить",
    [EP.ADMIN_OFFERS_USERS_GUARANTEES_CREATE]: "Создать",
    [EP.ADMIN_OFFERS_USERS_GUARANTEES_UPDATE]: "Обновить",
    [EP.ADMIN_OFFERS_USERS_GUARANTEES_DELETE]: "Удалить",

    // Админ – Журналы гарантий по офферам
    [EPM.ADMIN_GUARANTEES_LOGS]: "Журналы гарантий по офферам",
    [EP.ADMIN_GUARANTEES_LOGS_LIST]: "Список",
    [EP.ADMIN_GUARANTEES_LOGS_GET]: "Получить",
    [EP.ADMIN_GUARANTEES_LOGS_CREATE]: "Создать",
    [EP.ADMIN_GUARANTEES_LOGS_UPDATE]: "Обновить",
    [EP.ADMIN_GUARANTEES_LOGS_DELETE]: "Удалить",


    // Администратор - Гарантии пользователей по предложениям
    [EPM.ADMIN_OFFERS_TRACKING_LINKS]: "Гарантии пользователей по Офферы",
    [EP.ADMIN_OFFERS_TRACKING_LINKS_LIST]: "Список",
    [EP.ADMIN_OFFERS_TRACKING_LINKS_CREATE]: "Создать",
    [EP.ADMIN_OFFERS_TRACKING_LINKS_DELETE]: "Удалить",
    // Администратор - Домены
    [EPM.ADMIN_DOMAINS]: "Домены",
    [EP.ADMIN_DOMAINS_LIST]: "Список",
    [EP.ADMIN_DOMAINS_GET]: "Получить",
    [EP.ADMIN_DOMAINS_CREATE]: "Создать",
    [EP.ADMIN_DOMAINS_UPDATE]: "Обновить",
    [EP.ADMIN_DOMAINS_DELETE]: "Удалить",
    // Администратор - Новости
    [EPM.ADMIN_NEWS]: "Новости",
    [EP.ADMIN_NEWS_LIST]: "Список",
    [EP.ADMIN_NEWS_GET]: "Получить",
    [EP.ADMIN_NEWS_CREATE]: "Создать",
    [EP.ADMIN_NEWS_UPDATE]: "Обновить",
    [EP.ADMIN_NEWS_DELETE]: "Удалить",
    // Администратор - Посадочные страницы
    [EPM.ADMIN_LANDINGS]: "Посадочные страницы",
    [EP.ADMIN_LANDINGS_LIST]: "Список",
    [EP.ADMIN_LANDINGS_GET]: "Получить",
    [EP.ADMIN_LANDINGS_CREATE]: "Создать",
    [EP.ADMIN_LANDINGS_UPDATE]: "Обновить",
    [EP.ADMIN_LANDINGS_DELETE]: "Удалить",
    // Администратор - Предварительные посадочные страницы
    [EPM.ADMIN_PRELANDINGS]: "Предварительные посадочные страницы",
    [EP.ADMIN_PRELANDINGS_LIST]: "Список",
    [EP.ADMIN_PRELANDINGS_GET]: "Получить",
    [EP.ADMIN_PRELANDINGS_CREATE]: "Создать",
    [EP.ADMIN_PRELANDINGS_UPDATE]: "Обновить",
    [EP.ADMIN_PRELANDINGS_DELETE]: "Удалить",
    // Администратор - Баланс
    [EPM.ADMIN_BALANCE]: "Баланс",
    [EP.ADMIN_BALANCE_LIST]: "Список",
    [EP.ADMIN_BALANCE_UPDATE]: "Обновить",
    [EP.ADMIN_BALANCE_DELETE]: "Удалить",
    // Администратор - История входов
    [EPM.ADMIN_LOGIN_HISTORY]: "История входов",
    [EP.ADMIN_LOGIN_HISTORY_LIST]: "Список",
    [EP.ADMIN_LOGIN_HISTORY_GET]: "Получить",
    [EP.ADMIN_LOGIN_HISTORY_DELETE]: "Удалить",
    // Администратор - Логи - Очередь электронной почты
    [EPM.ADMIN_LOGS]: "Логи Администратора",
    [EP.ADMIN_LOGS_QUEUE_EMAIL]: "Очередь электронной почты",
    // Администратор - Платежи
    [EPM.ADMIN_PAYMENTS]: "Платежи",
    [EP.ADMIN_PAYMENTS_LIST]: "Список",
    [EP.ADMIN_PAYMENTS_CREATE]: "Создать",
    [EP.ADMIN_PAYMENTS_UPDATE]: "Обновить",
    [EP.ADMIN_PAYMENTS_TOTAL]: "Всего",
    [EP.ADMIN_PAYMENTS_MASS]: "Массовый Запрос на Выплату",

    // Администратор - Заказы
    [EPM.ADMIN_ORDERS]: "Лиды",
    [EP.ADMIN_ORDERS_LIST]: "Список",
    [EP.ADMIN_ORDERS_LOGS]: "Логи",
    [EP.ADMIN_ORDERS_COUNTER]: "Счетчик",
    [EP.ADMIN_ORDERS_UPDATE]: "Обновить",
    // Администратор - Ошибки заказов
    [EPM.ADMIN_ORDERS_ERRORS]: "Ошибки заказов",
    [EP.ADMIN_ORDERS_ERRORS_LIST]: "Список",
    [EP.ADMIN_ORDERS_ERRORS_GET]: "Получить",
    [EP.ADMIN_ORDERS_ERRORS_UPDATE]: "Обновить",
    [EP.ADMIN_ORDERS_ERRORS_DELETE]: "Удалить",
    [EP.ADMIN_ORDERS_ERRORS_RESEND]: "Повторить отправку",
    // Администратор - Пополнения
    [EPM.ADMIN_TOPUPS]: "Пополнения",
    [EP.ADMIN_TOPUPS_LIST]: "Список",
    [EP.ADMIN_TOPUPS_GET]: "Получить",
    [EP.ADMIN_TOPUPS_CREATE]: "Создать",
    [EP.ADMIN_TOPUPS_UPDATE]: "Обновить",
    [EP.ADMIN_TOPUPS_DELETE]: "Удалить",
    // Администратор - Быстрый вход
    [EPM.ADMIN_FAST_LOGIN]: "Быстрый вход",
    [EP.ADMIN_FAST_LOGIN_CREATE]: "Создать",
    [EP.ADMIN_FAST_LOGIN_CHECK]: "Проверить",
    // Администратор - Логи Postback
    [EPM.ADMIN_POSTBACK_LOGS]: "Логи постбеов",
    [EP.ADMIN_POSTBACK_LOGS_LIST]: "Список",
    // Администратор - Журнал изменений
    [EPM.ADMIN_CHANGELOG]: "Журнал изменений",
    [EP.ADMIN_CHANGELOG_LIST]: "Список",
    [EP.ADMIN_CHANGELOG_UPDATE]: "Обновить",
    [EP.ADMIN_CHANGELOG_CREATE]: "Создать",
    [EP.ADMIN_CHANGELOG_DELETE]: "Удалить",
    // Администратор - Профиль
    [EP.ADMIN_USERS_GET]: "Получить",
    [EP.ADMIN_USERS_UPDATE]: "Обновить",
    // Администратор - Страна
    [EPM.ADMIN_COUNTRY]: "Страна",
    [EP.ADMIN_COUNTRY_LIST]: "Список",

    common: "Общее",
  },

  DashboardFooter: {
    companyName: "MONETIZEAD",
    craftedLeft: "Crafted with",
    craftedRight: "MonetizeAd",
  },
  DashboardHeader: {
    balance: { label: "Баланс", tooltip: "Проверить баланс профиля" },
    manager: { label: "Менеджер", tooltip: "Информация о менеджере" },
    news: { label: "Новости", tooltip: "Просмотреть новости" },
    tableView: "Табличный вид",
    gridView: "Вид сетки",
    balanceWidget: {
      balance: "Баланс",
      paid: "Оплачено",
      profit: "Прибыль",
      total: "Итого",
    },
    managerWidget: {
      name: "Имя",
    },
  },
  MonadLeadNews: {
    news: "новости",
    unread: "непрочитанные",
    category: "Категория",
    date: "Дата добавления",
  },
  AccountMenu: {
    profile: "Профиль",
    referralLink: "Реферальная ссылка",
    logout: "Выход",
    referralSuccessful: "Ссылка для рефералов успешно скопирована!",
    account_menu: "Меню аккаунта",
  },
  MenuFooter: {
    commonModalTranslations,
    mobileApp: "Приложение",
    qr: "Отсканируйте или нажмите на QR-код, чтобы скачать приложение",
    loginAs: "Войти как",
    logout: "Выход",
    confirm: "Подтвердить",
    backTo: "Вернуться к",
  },
  Logout: {
    title: "Выход",
    loading: "Ожидание безопасного выхода",
    completed: "Вы успешно вышли из системы",
    button: "Вернуться к входу",
  },
  Admission: {
    recaptcha_required: "Пожалуйста, подтвердите, что вы не робот.",
    username_required: "Имя пользователя обязательно",
    short_username: "Имя пользователя должно содержать не менее 4 символов",
    long_username: "Имя пользователя должно содержать не более 20 символов",
    pw_required: "Пароль обязателен",
    short_pw: "Пароль должен содержать не менее 4 символов",
    long_pw: "Пароль должен содержать не более 20 символов",
    username: "Имя пользователя",
    password: "Пароль",
    login: "Войти",
    forgot_pw: "Забыли пароль?",
    welcoming: "С возвращением",
    have_account: "Уже есть аккаунт?",
    no_account: "Нет аккаунта?",
    sign_in: "Войти",
    sign_up: "Зарегистрироваться",
    instead: "вместо этого",
    first_name: "Имя",
    welcome: "Добро пожаловать",
    firstname_required: "Имя обязательно",
    long_firstname: "Имя должно содержать не более 20 символов",
    short_firstname: "Имя должно содержать не менее 3 символов",
    last_name: "Фамилия",
    lastname_required: "Фамилия обязательна",
    short_lastname: "Фамилия должна содержать не менее 3 символов",
    long_lastname: "Фамилия должна содержать не более 20 символов",
    email_required: "Email обязателен",
    wrong_format: "Email в неправильном формате",
    email: "Email",
    register: "Зарегистрироваться",
    already_reg: "Уже зарегистрированы?",
    first_name_req: "Имя",
    request: "Запрос",
    remember_password: "Я помню свой пароль",
    successful_email:
      "Письмо с инструкциями по сбросу пароля успешно отправлено",
    email_already_sent:
      "Письмо для сброса пароля уже отправлено. Проверьте папку «Входящие» и «Спам».",
    password_reset_required_notice:
      "В целях безопасности требуется смена пароля. Эта мера действует для всех пользователей — сбросьте пароль, чтобы продолжить.",
    backto_login: "Вернуться к входу",
  },
  RequestErrors: {
    default: "Неизвестная ошибка",
    browser: {
      ERR_NETWORK: "Ошибка сети",
    },
    network: {
      401: "Неаутентифицированный пользователь",
      403: "Недостаточно прав",
      405: "Метод не разрешен",
      406: "Запрос не принят",
    },
    internal: {
      1: "Запрошенный метод не разрешен",
      2: "Информация для входа в систему не была передана",
      3: "Неверный формат имени пользователя",
      4: "Неверный формат пароля",
      5: "Неверные данные входа",
      6: "Ошибка базы данных",
      7: "Неправильный формат запроса POST",
      8: "Неверный формат поля",
      9: "Запись уже существует в базе данных",
      10: "ID должен быть передан через метод GET",
      11: "Запрошенный ID не найден в базе данных",
      12: "Один из параметров поиска должен быть передан",
      13: "Неверный формат параметра GET",
      14: "Запрошенный пользователь не найден в базе данных",
      15: "Запрошенная страна не найдена в базе данных",
      16: "У пользователя нет разрешения на запрошенный модуль / действие",
      17: "Имя таблицы mysql должно быть передано",
      18: "Значение не найдено в выбранной базе данных",
      19: "Ошибка при передаче параметров ключа / значения",
      20: "Формат файла не разрешен",
      21: "Категория не найдена в таблице",
      22: "Продукт не найден в таблице",
      23: "ID продукта не был передан",
      24: "Вариант не найден в таблице",
      25: "Выбранная таблица не может быть просмотрена с использованием этого метода",
      26: "Невозможно найти пользователя. Общая ошибка",
      27: "Запрошенный номер не найден или используется в одной из кампаний",
      28: "Нет пользователей для выплаты за запрошенный период",
      29: "Разрешено только удаление ожидающей выплаты",
      30: "Необходимо передать параметр: статус",
      31: "Невозможно переключиться с существующего на запрошенный статус",
      32: "Контакт был взят или уже принадлежит пользователю",
      33: "Запись уже была получена в системе",
      34: "Необходимо передать статус через метод GET",
      35: "Тикет не существует или закрыт для дальнейшего ответа",
      36: "У пользователя нет активного выбранного метода оплаты",
      37: "Введенной вами суммы недостаточно для выбранного метода",
      38: "Выбранный метод в настоящее время недоступен для использования",
      39: "Выбранный метод в настоящее время неактивен на вашем аккаунте",
      40: "У вас в настоящее время недостаточно средств на счете",
      41: "Необходимо передать имя пользователя через параметр запроса",
      42: "Невозможно найти пользователя в базе данных",
      43: "Ссылка для сброса пароля уже была запрошена для пользователя. Проверьте свой спам / нежелательную почту",
      44: "Токен не найден",
      45: "Вам нужно повторно ввести пароль правильно",
      46: "Менеджер не назначен пользователю",
      47: "Этот пользователь не принадлежит вам",
      48: "Этот пользователь уже был принят",
      //49 - edited payout in cost
      49: "Рекламная стоимость должна быть больше выплаты партнеру",
      50: "Ошибка при отправке заказа рекламодателю",
      51: 'Условие уже создано.',
      52: 'Метод оплаты не активен',
      53: 'Значение меньше допустимого',
      54: 'Значение больше допустимого',
      55: 'Введённый контактный номер неверен.'
    },
    custom: {},
  },

  modal: {
    info: "Информация",
    affectedRows: "Затронутые строки",
    overrides: "Переопределения",
  },

  [moduleNames.ADMIN_DASHBOARD]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Панель управления",
    statistics: "Статистика",
    event: "Cобытие",
    advertiserCost: "Стоимость рекламодателя",
    confirmed: "Подтверждено",
    hold: "В холде",
    cancelled: "Отменено",
    trash: "В Треше",
    affiliate: "Партнер",
    affiliates: "Филиалы",
    advertisers: "Рекламодатели",
    advertiser_cost: "Ad. расходы",
    canceled: "Отменено",
    username: "Имя пользователя",
    country_name: "Страна",
    ar: "AR",
    offer_name: "Оффер",
    countries: "Страны",
    no_filters: "Фильтры не добавлены",
    advertiser: "Рекламодатель",
    offers: "Офферы",
    no_data: "Нет данных",
    total: "Всего",
    payout: "Выплата",
    profit: "Выгода",
    ad_cost: "Стоимость рекламы",
    referralLink: "Реферальная ссылка",
    profile: "Профиль",
    logout: "Выйти",
    approve_rate: "Ставка подтверждения",
    country_code: "Код страны",

    filters: {
      advertiser_id: {
        label: "рекламодатель",
        description: "Поиск по имени пользователя",
      },
      affiliate_id: {
        label: "партнер",
        description: "Поиск по имени пользователя",
      },
      manager_id: { label: "mенеджер", description: "Поиск по имени пользователя" },
      offer_id: { label: "Офферы", description: "Поиск по названию" },
    },
    rangeShortcuts: {
      today: "Сегодня",
      yesterday: "Вчера",
      thisWeek: "На этой неделе",
      lastWeek: "На прошлой неделе",
      last7Days: "Последние 7 дней",
      currentMonth: "Текущий месяц",
      lastMonth: "Прошлый месяц",
      selectDate: "Выбрать диапазон дат",
      cancelButton: "Отмена",
      clearButton: "Очистить",
      dateFrom: "Дата начала",
      dateTo: "Конец",
    },
  },
  [moduleNames.ADMIN_REPORT_BALANCE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Отчет о балансе",
    columns: {
      "info.id": "Идентификатор",
      "data.username": "Имя пользователя",
      "data.balance": "Всего заработано",
      "data.total_withdrawn": "Всего выведено",
      "data.rest": "Остаток",
    },
    filters: {
      user_id: { label: "Пользователь", description: "Поиск по имени пользователя" },
      manager_id: { label: "Менеджер", description: "Поиск по имени пользователя" },
    },
  },
  [moduleNames.ADMIN_REPORT_OFFERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Отчет о Офферы",
    columns: {
      "info.offer_id": "ID Офферы",
      "data.offer_name": "Название Oфферы",
      "data.hold": "В холде",
      "data.trash": "В Треше",
      "data.canceled": "Отменено",
      "data.confirmed": "Подтверждено",
      "data.total": "Всего",
      "data.ar": "Показатель одобрения",
      "data.payout": "Выплата",
      "data.advertiser_cost": "Затраты рекламодателя",
      "data.profit": "Прибыль",
    },
    filters: {
      affiliate_id: { label: "Афф. ID", description: "Поиск по Афф. ID" },
      affiliate_username: { label: "Афф. Имя пользователя", description: "Поиск по Афф. Имени пользователя" },
      affiliate_safe_id: { label: "Афф. SafeId", description: "Поиск по Афф. SafeId" },

      advertiser_id: { label: "Рекл. ID", description: "Поиск по Рекл. ID" },
      advertiser_username: { label: "Рекл. Имя пользователя", description: "Поиск по Рекл. Имени пользователя" },
      advertiser_safe_id: { label: "Рекл. SafeId", description: "Поиск по Рекл. SafeId" },
      offer_id: { label: "Офферы", description: "Поиск по названию" },
      country_code: { label: "Страна" },
      date_range: { label: "Диапазон дат" },
      manager_id: { label: "Менеджер", description: "Поиск по имени пользователя" }

    },
  },
  [moduleNames.ADMIN_OFFERS_BLACKLIST_USERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Черный список пользователей",
    createLabel: "Добавить",
    editLabel: "Изменить",
    editBulkLabel: "Изменить",
    addModalTitle: "Добавить",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить",
    deleteModalBulkTitle: "Удалить",
    columns: {
      'info.id': "ID",
      'username': "Имя пользователя",
      'user_id': "Идентификатор пользователя",
      'offer_name': "оффер",
      'offer_id': "ID оффера",
      'timestamp': "Создано",
    },
    filters: {
      user_id: { label: 'Пользователь', description: 'Поиск по имени пользователя' },
      offer_id: { label: 'Оффер', description: 'Поиск по названию' },
    },
    formData: {
      userId: { label: 'Пользователь', description: 'Поиск по имени пользователя' },
      offerId: { label: 'Оффер', description: 'Поиск по названию' },
    }
  },
  [moduleNames.ADMIN_REPORT_USERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Отчет о пользователях",
    columns: {
      "info.user_id": "Идентификатор пользователя",
      "data.username": "Имя пользователя",
      "data.hold": "В холде",
      "data.trash": "В Треше",
      "data.canceled": "Отменено",
      "data.confirmed": "Подтверждено",
      "data.total": "Всего",
      "data.ar": "Показатель одобрения",
      "data.payout": "Выплата",
      "data.advertiser_cost": "Затраты рекламодателя",
      "data.profit": "Прибыль",
    },
    filters: {
      affiliate_id: { label: "Афф. ID", description: "Поиск по Афф. ID" },
      affiliate_username: { label: "Афф. Имя пользователя", description: "Поиск по Афф. Имени пользователя" },
      affiliate_safe_id: { label: "Афф. SafeId", description: "Поиск по Афф. SafeId" },

      advertiser_id: { label: "Рекл. ID", description: "Поиск по Рекл. ID" },
      advertiser_username: { label: "Рекл. Имя пользователя", description: "Поиск по Рекл. Имени пользователя" },
      advertiser_safe_id: { label: "Рекл. SafeId", description: "Поиск по Рекл. SafeId" },
      offer_id: { label: "Офферы", description: "Поиск по названию" },
      country_code: { label: "Страна" },
      date_range: { label: "Диапазон дат" },
      manager_id: { label: "Менеджер", description: "Поиск по имени пользователя" }

    },
  },
  [moduleNames.ADMIN_REPORT_COUNTRIES]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Отчет по странам",
    columns: {
      "data.country_code": "Страна",
      "data.hold": "В холде",
      "data.trash": "В Треше",
      "data.canceled": "Отменено",
      "data.confirmed": "Подтверждено",
      "data.total": "Всего",
      "data.ar": "Показатель одобрения",
      "data.payout": "Выплата",
      "data.advertiser_cost": "Стоимость рекламодателя",
      "data.profit": "Прибыль",
    },
    filters: {
      affiliate_id: { label: "Афф. ID", description: "Поиск по Афф. ID" },
      affiliate_username: { label: "Афф. Имя пользователя", description: "Поиск по Афф. Имени пользователя" },
      affiliate_safe_id: { label: "Афф. SafeId", description: "Поиск по Афф. SafeId" },

      advertiser_id: { label: "Рекл. ID", description: "Поиск по Рекл. ID" },
      advertiser_username: { label: "Рекл. Имя пользователя", description: "Поиск по Рекл. Имени пользователя" },
      advertiser_safe_id: { label: "Рекл. SafeId", description: "Поиск по Рекл. SafeId" },
      offer_id: { label: "Оффер", description: "Поиск по названию" },
      country_code: { label: "Страна" },
      date_range: { label: "Диапазон дат" },
      manager_id: { label: "Менеджер", description: "Поиск по имени пользователя" }
    },
  },
  [moduleNames.ADMIN_REPORT_ADVERTISERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Отчет по рекламодателям",
    columns: {
      "username-id": "Рекламодатель",
      "data.hold": "В холде",
      "data.trash": "В Треше",
      "data.canceled": "Отменено",
      "data.confirmed": "Подтверждено",
      "data.total": "Всего",
      "data.ar": "Показатель одобрения",
      "data.payout": "Выплата",
      "data.advertiser_cost": "Стоимость рекламодателя",
      "data.profit": "Прибыль",
    },
    filters: {
      affiliate_id: { label: "Афф. ID", description: "Поиск по Афф. ID" },
      affiliate_username: { label: "Афф. Имя пользователя", description: "Поиск по Афф. Имени пользователя" },
      affiliate_safe_id: { label: "Афф. SafeId", description: "Поиск по Афф. SafeId" },

      advertiser_id: { label: "Рекл. ID", description: "Поиск по Рекл. ID" },
      advertiser_username: { label: "Рекл. Имя пользователя", description: "Поиск по Рекл. Имени пользователя" },
      advertiser_safe_id: { label: "Рекл. SafeId", description: "Поиск по Рекл. SafeId" },
      offer_id: { label: "Оффер", description: "Поиск по названию" },
      country_code: { label: "Страна" },
      date_range: { label: "Диапазон дат" },
      manager_id: { label: "Менеджер", description: "Поиск по имени пользователя" }
    },
  },
  [moduleNames.ADMIN_REPORT_DYNAMICS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Динамический отчет",
    columns: {
      date: "Дата",
      affiliate: "Партнёр",
      advertiser: "Рекламодатель",
      manager: "Менеджер",
      landing_name: "Лендинг",
      prelanding_name: "Прелендинг",
      offer_name: "Офферы",
      country_code: "Страна",
      sub_1: "Sub 1",
      sub_2: "Sub 2",
      sub_3: "Sub 3",
      sub_4: "Sub 4",
      device_type: "Устройство",
      browser_name: "Браузер",
      browser_version: "Версия браузера",
      os_name: "ОС",
      os_version: "Версия ОС",
      total: "Всего",
      hold: " В холде",
      confirmed: "Подтверждено",
      trash: " В Треше",
      canceled: "Отменено",
      approved_rate: "Показатель одобрения",
      expected_ar: "Ожидаемый показатель одобрения",
      trash_rate: "Коэффициент удаления",
      canceled_rate: "Коэффициент отмены",
      payout: "Выплата",
      advertiser_cost: "Затраты рекламодателя",
      profit: "Прибыль",
      earnings_per_hold: "Заработок с удержания",
      earnings_per_confirmed: "Заработок с подтверждения",
      utm_source: 'Источник UTM',
      utm_medium: 'Канал UTM',
      utm_campaign: 'Кампания UTM',
      utm_term: 'Ключевое слово UTM',
      utm_content: 'Контент UTM',
      category: 'Категория',
      vertical: 'Вертикаль',

    },
    filters: {
      category: { label: 'Категория' },
      vertical: { label: "Вертикаль" },
      affiliate_id: { label: "Афф. ID", description: "Поиск по Афф. ID" },
      affiliate_username: { label: "Афф. Имя пользователя", description: "Поиск по Афф. Имени пользователя" },
      affiliate_safe_id: { label: "Афф. SafeId", description: "Поиск по Афф. SafeId" },

      advertiser_id: { label: "Рекл. ID", description: "Поиск по Рекл. ID" },
      advertiser_username: { label: "Рекл. Имя пользователя", description: "Поиск по Рекл. Имени пользователя" },
      advertiser_safe_id: { label: "Рекл. SafeId", description: "Поиск по Рекл. SafeId" },

      user_id: {
        label: "Пользователь",
        description: "Поиск по имени пользователя",
      },
      offer_id: { label: "Офферы", description: "Поиск по названию" },
      country_code: { label: "Страна" },
      lp: { label: "Лендинг", description: "Поиск по названию" },
      prelp: { label: "Прелендинг", description: "Поиск по названию" },
      sub_1: { label: "Sub 1" },
      sub_2: { label: "Sub 2" },
      sub_3: { label: "Sub 3" },
      sub_4: { label: "Sub 4" },
      utm_campaign: { label: "UTM кампания", description: "Поиск по UTM кампании" },
      utm_content: { label: "UTM контент", description: "Поиск по UTM контенту" },
      utm_medium: { label: "UTM канал", description: "Поиск по UTM каналу" },
      utm_source: { label: "Источник UTM", description: "Поиск по источнику UTM" },
      utm_term: { label: "UTM ключевое слово", description: "Поиск по UTM ключевому слову" },
      date_range: { label: "Диапазон дат" },
    },
  },
  [moduleNames.ADMIN_REPORT_ORDERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Отчет по заказам",
    editLabel: "Редактировать",
    logsLabel: "Логи",
    editBulkLabel: "Редактировать",
    editModalTitle: "Редактировать заказ",
    editModalBulkTitle: "Редактировать заказы",
    reqResModalTitle: "Логи Req/Res",
    columns: {
      "info.id": "ID",
      name: "Имя",
      phone: "Телефон",
      "offer.id": "ID оффера",
      "offer.name": "Название оффера",
      "advertiser.offer_id": "ID оффера рекламодателя",
      "info.advertiser_id": "ID рекламодателя",
      "info.advertiser_username": "Рекламодатель",
      "info.status": "Статус",
      "info.before_status": "Предыдущий статус",
      "info.affiliate_id": "ID партнера",
      "info.affiliate_username": "Партнер",
      "flow.landings.id": "ID лендинга",
      "flow.landings.name": "Название лендинга",
      "flow.prelandings.id": "ID прелендинга",
      "flow.prelandings.name": "Название прелендинга",
      country_code: "Страна",
      quantity: "Количество",
      "tracking.user_ip": "IP пользователя",
      "created.timestamp": "Создано",
      base_url: "Базовый URL",
      referrer: "Реферер",
      "tracking.sub_1": "Sub 1",
      "tracking.sub_2": "Sub 2",
      "tracking.sub_3": "Sub 3",
      "tracking.sub_4": "Sub 4",
      "tracking.os_name": "Название ОС",
      "tracking.os_version": "Версия ОС",
      "tracking.browser_name": "Название браузера",
      "tracking.browser_version": "Версия браузера",
      "tracking.safe_id": "Безопасный ID",
      "tracking.click_id": "ID клика",
      "tracking.device_type": "Тип устройства",
      "tracking.external_id": "Внешний ID",
      "tracking.utm_term": "UTM термины",
      "tracking.utm_medium": "UTM среда",
      "tracking.utm_source": "UTM источник",
      "tracking.utm_content": "UTM контент",
      "tracking.utm_campaign": "UTM кампания",
      "info.last_update": "Последнее обновление",
      "info.counter": "Счетчик",
      test_mode: "Тестовый режим",
      "advertiser_cost": "Стоимость рекламодателя",
      "affiliate_payout": "Выплата партнеру",
    },
    filters: {
      id: { label: "ID" },

      affiliate_id: { label: "ID партнера", description: "Поиск по ID партнера" },
      affiliate_username: { label: "Имя партнера", description: "Поиск по имени партнера" },
      affiliate_safe_id: { label: "Безопасный ID партнера", description: "Поиск по безопасному ID партнера" },

      advertiser_id: { label: "ID рекламодателя", description: "Поиск по ID рекламодателя" },
      advertiser_username: { label: "Имя рекламодателя", description: "Поиск по имени рекламодателя" },
      advertiser_safe_id: { label: "Безопасный ID рекламодателя", description: "Поиск по безопасному ID рекламодателя" },

      country_code: { label: "Страна", description: "Поиск по названию страны" },
      offer_id: { label: "Оффер", description: "Поиск по названию оффера" },
      prelanding_id: { label: "Прелендинг", description: "Поиск по названию" },
      landing_id: { label: "Лендинги", description: "Поиск по названию" },
      tracking_sub_1: { label: "Sub 1" },
      tracking_sub_2: { label: "Sub 2" },
      tracking_sub_3: { label: "Sub 3" },
      tracking_sub_4: { label: "Sub 4" },
      tracking_click_id: { label: "ID клика для отслеживания" },
      name: { label: "Имя" },
      external_id: { label: "Внешний ID" },
      phone: { label: "Номер телефона" },
      status: { label: "Статус" },
      date_range: { label: "Диапазон дат" },
    },
    formData: {
      country_code: { label: "Страна", description: "Поиск по названию страны" },
      name: { label: "Имя" },
      phone: { label: "Телефон" },
      user_ip: { label: "IP пользователя" },
      test_mode: { label: "Тестовый режим" },
      advertiserOfferId: { label: "ID оффера рекламодателя" },
      reset_counter: { label: "Сбросить счетчик" },
    },
  },


  [moduleNames.ADMIN_OFFERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Офферы",
    createLabel: "Добавить Офферы",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать Офферы",
    editModalTitle: "Редактировать Офферы",
    editModalBulkTitle: "Редактировать oфферы",
    payourOffersLabel: "Выплаты oфферы",
    payourUsersLabel: "Выплаты пользователей",
    noOptionsText: "Требуется выбрать категорию",
    copyLinkLabel: 'Скопировать URL',
    copyLinkSuccessMessage: 'Ссылка скопирована в буфер обмена',
    viewOfferLabel: 'Посмотреть предложение',
    tabs: {
      info: "Информация*",
      target: "Цель*",
      advertiser: "Рекламодатель*",
      overrides: "Переопределения",
      affectedRows: "Затронутые строки",
    },
    columns: {
      "info.id": "Идентификатор",
      "data.name": "Название",
      "data.access": "Доступ",
      "data.status": "Статус",
      "data.paid_status": "Оплаченный статус",
      "data.info.ar": "Показатель одобрения",
      "data.info.cr": "Коэффициент конверсии",
      "data.info.epc": "Заработок с клика",
      "data.advertiser.id": "ID рекламодателя",
      "data.advertiser.name": "Рекламодатель",
      "data.advertiser.offer_id": "ID oфферы рекламодателя",
      "data.category.id": "Категория",
      "data.advertiser.expected_ar":
        "Ожидаемый показатель одобрения рекламодателя",
      "data.main_country_code": "Основная страна",
      "data.advertiser.advertiser_guarantees": "Гарантии рекламодателя",
      "data.advertiser.guaranteed_ar":
        "Гарантированный показатель одобрения рекламодателя",
      "data.advertiser.min_orders":
        "Минимальное количество заказов по гарантии рекламодателя",
      "data.advertiser.timeframe":
        "Временной промежуток гарантии рекламодателя",
      "data.device": "Устройство",
      "data.vertical": "Вертикаль",
      "data.region": "Регион",
      "data.flow": "Flow",
      "data.monadlead_tokens": "Токены MonadLead",
      "info.affiliate_payout": "Выплата",
      "info.advertiser_cost": "Расходы",
      "info.price": "Цена"
    },
    filters: {
      id: { label: "Идентификатор", description: "Поиск по ID" },
      name: { label: "Название" },
      advertiser_id: {
        label: "Рекламодатель",
        description: "Поиск по имени пользователя",
      },
      category_id: { label: "Категория" },
      vertical_id: { label: "Вертикаль", description: 'Выберите категорию' },
      region_id: { label: "Регион" },
      status: { label: "Статус" },
      paid_status: { label: "Оплаченный статус" },
      main_country_code: { label: "Основная страна" },
      advertiser_offer_id: { label: "Идентификатор предложения рекламодателя" },
      access: { label: "Доступ", description: 'Поиск по доступу' },
    },
    formData: {
      name: { label: "Название", placeholder: "Название oфферы" },
      access: { label: "Доступ", placeholder: "Уровень доступа к предложению" },
      status: { label: "Статус" },
      paidStatus: { label: "Оплаченный статус" },
      mainCountry: { label: "Основная страна" },
      description: { label: "Описание" },
      image: { label: "Изображение" },
      categoryId: { label: "Категория" },
      vertical: { label: "Вертикаль" },
      flow: { label: "Flow" },
      device: { label: "Устройство" },
      advertiserId: { label: "Рекламодатель" },
      offerId: { label: "Офферы" },
      expectedAr: { label: "Ожидаемый AR" },
      guaranteedAr: { label: "Гарантированный AR" },
      minOrders: { label: "Минимальное количество заказов" },
      timeframe: { label: "Временной промежуток" },
      advertiserGuarantees: { label: "Гарантии рекламодателя" },
      ar: { label: "Показатель одобрения" },
      cr: { label: "Коэффициент конверсии" },
      epc: { label: "Заработок с клика" },
      tokens: { label: "Токены MonadLead" },
    },
  },
  [moduleNames.ADMIN_OFFERS_SUBSCRIPTIONS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Подписки",
    editLabel: "Редактировать",
    logsLabel: "Логи",
    editBulkLabel: "Редактировать",
    editModalTitle: "Редактировать заказ",
    editModalBulkTitle: "Редактировать заказы",
    approveModalTitle: "Одобрить оплату подписки",
    approveModalBody: "Сумма, которая будет добавлена на баланс",
    payments: "Платежи",
    approveLabel: "Одобрить",
    totalLabel: "Всего",
    columns: {
      id: "ID",
      "affiliate.id": "ID аффилиата",
      "affiliate.name": "Аффилиат",
      "offer.id": "ID предложения",
      "offer.name": "Название предложения",
      "advertiser.name": "Рекламодатель",
      "advertiser.id": "ID рекламодателя",
      "tracking_link.name": "Трекинговая ссылка",
      "tracking_link.id": "ID трекинговой ссылки",
      rev_share: "Доля дохода",
      subscriber: "Подписчик",
      status: "Статус",
      expiration_date: "Дата окончания",
    },
    filters: {
      "offer.name": { label: "Предложение", description: "Поиск по названию предложения" },
      "affiliate.name": { label: "Аффилиат", description: "Поиск по имени аффилиата" },
      "advertiser.name": { label: "Рекламодатель", description: "Поиск по имени рекламодателя" },
      "advertiser.id": { label: "ID рекламодателя", description: "Поиск по ID рекламодателя" },
      status: { label: "Статус" },
    },
    formData: {
      rev_share: { label: "Доля дохода" },
      expiration_date: { label: "Дата окончания" },
      status: { label: "Статус" },
    },
  },
  [moduleNames.ADMIN_OFFERS_SUBSCRIPTIONS_PAYMENTS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    moduleTitle: "Выплаты",
    createLabel: "Добавить выплату",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать выплату",
    editModalTitle: "Редактировать выплату",
    editModalBulkTitle: "Редактировать выплаты",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить выплату",
    deleteModalBulkTitle: "Удалить выплаты",
    columns: {
      description: 'Описание',
      amount: 'Сумма',
      rev_share: 'Доля от выручки',
      status: 'Статус',
    },
    filters: {
      status: { label: "Статус" },
    },
    formData: {

    },

  },

  [moduleNames.ADMIN_CHANGELOG]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Журнал изменений",
    createLabel: "Добавить запись",
    editLabel: "Редактировать",
    deleteLabel: "Удалить",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать запись",
    editModalTitle: "Редактировать запись",
    editModalBulkTitle: "Редактировать записи",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить запись",
    deleteModalBulkTitle: "Удалить записи",
    columns: {
      "info.id": "ID",
      "info.subject": "Тема",
      "info.change_group": "Группа изменений",
      "info.type": "Тип",
    },
    filters: {
      change_group: { label: "Общее" },
      type: { label: "Тип" },
      subject: { label: "Тема" },
    },

    formData: {
      subject: { label: "Тема" },
      change_group: { label: "Группа изменений" },
      type: { label: "Тип" },
      text: { label: "Текст" },
    },
  },
  [moduleNames.ADMIN_OFFERS_PAYOUT_OFFERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    moduleTitle: "Выплаты",
    createLabel: "Добавить запись",
    createOfferLabel: "Создать выплату за oфферы",
    createUserLabel: "Создать выплату",
    createOfferBulkLabel: "Создать выплаты за oфферы",
    createUserBulkLabel: "Создать выплаты за oфферы для пользователей",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addOfferModalTitle: "Создать выплату за oфферы",
    addUserModalTitle: "Создать выплату предложения",
    editOfferModalTitle: "Редактировать",
    editModalBulkTitle: "Редактировать выплаты",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить выплату",
    deleteModalBulkTitle: "Удалить выплаты",
    addOfferModalBulkTitle: "Создать выплаты за oфферы",
    addUserModalBulkTitle: "Создать выплаты за oфферы для пользователей",
    tabs: {
      info: "Информация",
      newRecord: "Новая запись",
    },
    columns: {
      "info.id": "ID",
      "info.offer_id": "ID оффера",
      "info.offer_name": "Оффер",
      "info.username": "Имя пользователя",
      "info.safe_id": "SafeId",
      "data.code": "Страна",
      "data.limit": "Лимит",
      "data.price": "Цена",
      "data.advertiser_cost": "Затраты рекламодателя",
      "data.affiliate_payout": "Выплата партнёру",
    },
    filters: {
      table: { label: "Таблица" },
      user_id: {
        label: "Пользователь",
        description: "Поиск по имени пользователя",
      },
      advertiser_id: { label: "Рекламодатель", description: "Поиск по имени пользователя" },
      offer_id: { label: "Оффер", description: "Поиск по названию" },
      country_code: { label: "Страна" },
      limit: { label: "Ограничение" }
    },
    formData: {
      countryCode: { label: "Страна" },
      price: { label: "Цена", description: "25 KM*" },
      limit: { label: "Лимит", },
      limit_value: { label: "Значение лимита" },
      advertiserCost: { label: "Затраты рекламодателя" },
      affiliatePayout: { label: "Выплата партнёру" },
      offerId: { label: "Оффер" },
      userId: { label: "Пользователь" },
      type: { label: "Тип" },
      duration_days: { label: "Duration (days)" },
    },
  },
  [moduleNames.ADMIN_OFFERS_PAYOUT_OFFERS_SLIDE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    moduleTitle: "Выплаты",
    createLabel: "Добавить запись",
    createOfferLabel: "Создать выплату для оффера",
    createUserLabel: "Создать выплату для пользователя",
    createOfferBulkLabel: "Создать выплаты для офферов",
    createUserBulkLabel: "Создать выплаты для пользователей",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addOfferModalTitle: "Создать выплату для оффера",
    addUserModalTitle: "Создать выплату для пользователя",
    editOfferModalTitle: "Редактировать",
    editModalBulkTitle: "Редактировать выплаты",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить выплату",
    deleteModalBulkTitle: "Удалить выплаты",
    addOfferModalBulkTitle: "Создать выплаты для офферов",
    addUserModalBulkTitle: "Создать выплаты для пользователей",
    tabs: {
      info: "Информация",
      newRecord: "Новая запись",
    },
    columns: {
      "info.id": "ID",
      "info.offer_name": "Оффер",
      "data.code": "Страна",
      "data.limit": "Лимит",
      "data.price": "Цена",
      "data.advertiser_cost": "Затраты рекламодателя",
      "data.affiliate_payout": "Выплата партнёру",
    },
    filters: {
      user_id: { label: "Имя пользователя" },
      country_code: { label: "Страна" },
    },
    formData: {
      countryCode: { label: "Страна" },
      price: { label: "Цена", description: "25 KM*" },
      limit: { label: "Лимит", description: "200 / час*" },
      advertiserCost: { label: "Затраты рекламодателя" },
      affiliatePayout: { label: "Выплата партнёру" },
      offerId: { label: "Оффер" },
    },
  },

  [moduleNames.ADMIN_OFFERS_PAYOUT_USERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    moduleTitle: "Выплаты",
    createLabel: "Добавить выплату",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать выплату",
    editModalTitle: "Редактировать выплату",
    editModalBulkTitle: "Редактировать выплаты",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить выплату",
    deleteModalBulkTitle: "Удалить выплаты",
    columns: {
      "info.id": "ID",
      "info.offer_name": "Оффер",
      "info.username": "Имя пользователя",
      "data.code": "Страна",
      "data.limit": "Лимит",
      "data.price": "Цена",
      "data.advertiser_cost": "Затраты рекламодателя",
      "data.affiliate_payout": "Выплата партнёру",
    },
    filters: {
      user_id: { label: "Имя пользователя" },
      country_code: { label: "Страна" },
    },

    formData: {
      countryCode: { label: "Страна" },
      price: { label: "Цена", description: "25 KM*" },
      limit: { label: "Лимит", description: "200 / час*" },
      advertiserCost: { label: "Затраты рекламодателя" },
      affiliatePayout: { label: "Выплата партнёру" },
      userId: { label: "Пользователь" },
    },
  },
  [moduleNames.ADMIN_OFFERS_TRACKING_LINKS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    moduleTitle: "Выплаты",
    createLabel: "Добавить выплату",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать выплату",
    editModalTitle: "Редактировать выплату",
    editModalBulkTitle: "Редактировать выплаты",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить выплату",
    deleteModalBulkTitle: "Удалить выплаты",
    columns: {
      'id': "ID",
      'user_id': "ID пользователя",
      'advertiser_id': "ID рекламодателя",
      'name': "Имя",
      'offer_name': "Оффер",
      'offer_id': "ID оффера",
      'url': "URL",
      'updated_by': "Обновлено",
      'updated_at': "Обновлено в",
      'created_by': "Создано",
      'created_at': "Создано в",
      'track_subs_count': "Количество подписок",
      'clicks_count': 'Количество кликов',
      'track_total_revenue': "Общая выручка",
      'status': "Статус",
    },
    filters: {
      name: { label: 'Имя', description: 'Поиск по имени' },
      status: { label: 'Статус' },
    },
    formData: {
      name: { label: 'Имя', description: 'Поиск по имени' },
      userId: { label: 'Пользователь', description: 'Поиск по имени пользователя' },
      offerId: { label: 'Оффер', description: 'Поиск по имени' },
    }
  },
  [moduleNames.ADMIN_OFFERS_ACCESS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Доступ пользователей",
    createLabel: "Добавить доступ",
    approveLabel: "Утвердить",
    rejectLabel: "Отклонить",
    rejectBulkLabel: "Отклонить",
    approveBulkLabel: "Утвердить",
    addModalTitle: "Создать доступ",
    rejectModalTitle: "Отклонить доступ",
    rejectModalBulkTitle: "Отклонить доступы",
    approveModalTitle: "Утвердить доступ",
    approveModalBody: "Вы уверены, что хотите утвердить доступ?",
    approveModalBulk: "Вы уверены, что хотите принять эти идентификаторы?",
    columns: {
      "info.id": "ID",
      username: "Имя пользователя",
      user_id: "ID пользователя",
      offer_name: "Оффер",
      offer_id: "ID оффера",
      status: "Статус",
      comment: "Комментарий",
    },
    filters: {
      user_id: {
        label: "Пользователь",
        description: "Поиск по имени пользователя",
      },
      offer_id: { label: "Оффер", description: "Поиск по названию" },
      status: { label: "Статус" },
    },
    formData: {
      userId: {
        label: "Пользователь",
        description: "Поиск по имени пользователя",
      },
      offerId: { label: "Оффер", description: "Поиск по названию" },
      comment: { label: "Комментарий" },
      rejectComment: { label: "Комментарий отклонения" },
    },
  },
  [moduleNames.ADMIN_OFFERS_USERS_GUARANTEES]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Гарантии пользователей",
    createLabel: "Добавить запись",
    createAddSingleLabe: "Добавить гарантию",
    createAddBulkLabel: "Добавить гарантии",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать гарантию пользователя",
    editModalTitle: "Редактировать гарантию пользователя",
    editModalBulkTitle: "Редактировать гарантии пользователей",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить гарантию пользователя",
    deleteModalBulkTitle: "Удалить гарантии пользователей",
    addModalBulkTitle: "Создать гарантии пользователей",
    columns: {
      "info.id": "ID",
      "data.user_id": "ID пользователя",
      "info.username": "Имя пользователя",
      "data.offer_id": "ID oфферы",
      "info.offer_name": "Офферы",
      "data.guaranteed_ar": "Гарантированный AR",
      "data.min_orders": "Минимальное количество заказов",
      "data.timeframe": "Временной интервал",
      "data.timestamp": "Метка времени",
      "data.status": "Статус",
    },
    filters: {
      id: { label: "ID", description: "Поиск по ID" },
      user_id: { label: "ID пользователя" },
      offer_id: { label: "ID oфферы" },
      status: { label: "Статус" },
      username: { label: "Имя пользователя" },
      offer_name: { label: "Название предложения" },
      safe_id: { label: "Безопасный идентификатор" }
    },

    formData: {
      user: {
        label: "Пользователь",
        description: "Поиск по имени пользователя",
      },
      offer: { label: "Офферы", description: "Поиск по названию" },
      guaranteed_ar: { label: "Гарантированный AR" },
      min_orders: {
        label: "Минимальное количество заказов",
        description: "Число от 1 до 100",
      },
      status: { label: "Статус" },
      timeframe: {
        label: "Временной интервал",
        description: "Число от 1 до 365",
      },
    },
  },
  [moduleNames.ADMIN_GUARANTEES_LOGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Журналы гарантий",
    createLabel: "Добавить запись",
    createAddSingleLabe: "Добавить журнал гарантии",
    createAddBulkLabel: "Добавить журналы гарантий",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать журнал гарантии",
    editModalTitle: "Редактировать журнал гарантии",
    editModalBulkTitle: "Редактировать журналы гарантий",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить журнал гарантии",
    deleteModalBulkTitle: "Удалить журналы гарантий",
    addModalBulkTitle: "Создать журналы гарантий",
    columns: {
      "id": "ID",
      "user.id": "ID пользователя",
      "user.username": "Имя пользователя",
      "offer.name": "Оффер",
      "offer.id": "ID оффера",
      "order_id": "ID заказа",
      "data.guaranteed_ar": "Гарантированный AR",
      "from_status": "Из статуса",
      "to_status": "В статус",
      "date": "Дата",
      "data.timestamp": "Метка времени",
      "payout": "Выплата",
      "advertiser_cost": "Расход рекламодателя",
      "click_id": "ID клика",
    },
    filters: {
      table: { lablel: "Таблица" },
      id: { label: "ID", description: "Поиск по ID" },
      user_id: { label: "Партнёр", description: "Поиск по имени" },
      offer_id: { label: "Оффер", description: "Поиск по имени" },
      order_id: { label: "ID заказа" },
      from_status: { label: "Из статуса" },
      to_status: { label: "В статус" },
      date: { label: "Дата" },
      click_id: { label: "ID клика" }
    },

    formData: {
      user: { label: "Пользователь", description: "Поиск по имени пользователя" },
      offer: { label: "Оффер", description: "Поиск по названию" },
      guaranteed_ar: { label: "Гарантированный AR" },
      min_orders: {
        label: "Минимум заказов",
        description: "Число от 1 до 100",
      },
      status: { label: "Статус" },
      timeframe: {
        label: "Промежуток времени",
        description: "Число от 1 до 365",
      },
    },
  },

  [moduleNames.ADMIN_BALANCE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Баланс",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    editModalTitle: "Редактировать баланс",
    editModalBulkTitle: "Редактировать балансы",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить баланс",
    deleteModalBulkTitle: "Удалить балансы",
    columns: {
      "info.id": "ID",
      "data.affiliate": "Партнер",
      "data.advertiser": "Рекламодатель",
      "data.offer_name": "Название oфферы",
      "data.click_id": "ID клика",
      "data.payout": "Выплата",
      "data.advertiser_cost": "Стоимость рекламодателя",
      "data.timestamp": "Отметка времени",
    },
    filters: {
      user_id: { label: "Партнер", description: "Поиск по пользователю" },
      advertiser_id: {
        label: "Рекламодатель",
        description: "Поиск по имени пользователя",
      },
      offer_id: { label: "Офферы", description: "Поиск по oфферы" },
      payout: { label: "Выплата", description: "Поиск по выплате" },
      click_id: { label: "ID клика" },
    },

    formData: {
      payout: { label: "Выплата" },
      advertiser_cost: { label: "Стоимость рекламодателя" },
    },
  },
  [moduleNames.ADMIN_DOMAINS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Домены",
    createLabel: "Добавить домен",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать домен",
    editModalTitle: "Редактировать домен",
    editModalBulkTitle: "Редактировать домены",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить домен",
    deleteModalBulkTitle: "Удалить домены",
    columns: {
      "info.id": "ID",
      "data.domain": "Домен",
      "data.status": "Статус",
      "data.type": "Тип",
      "info.username": "Имя пользователя",
      "info.landing_name": "Целевая страница",
      "info.prelanding_name": "Предварительная страница",
    },
    filters: {
      id: { label: "ID" },
      user_id: { label: "Пользователь" },
      type: { label: "Тип" },
      status: { label: "Статус" },
    },
    formData: {
      domain: { label: "Домен" },
      status: { label: "Статус" },
      type: { label: "Тип" },
    },
  },
  [moduleNames.ADMIN_LOGIN_HISTORY]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - История входов",
    columns: {
      "info.id": "ID",
      ip: "IP",
      "info.username": "Имя пользователя",
      country_code: "Страна",
      status: "Статус",
      "data.os_type": "Устройство",
      "data.device_type": "Тип устройства",
      "data.os_title": "Название ОС",
      "data.browser_title": "Название браузера",
      "data.os_name": "Операционная система",
      "data.os_family": "Семейство ОС",
      "data.os_version": "Версия ОС",
      "data.64bits_mode": "Режим 64 бит",
      "data.browser_name": "Браузер",
      "data.browser_version": "Версия браузера",
      "data.browser_ios_webview": "Веб-просмотр IOS",
      "data.browser_desktop_mode": "Режим настольного компьютера браузера",
      "data.browser_gecko_version": "Версия Gecko браузера",
      "data.browser_webkit_version": "Версия Webkit браузера",
      "data.browser_android_webview": "Веб-просмотр Android",
      "data.browser_chrome_original": "Оригинальный Chrome браузера",
      "data.browser_safari_original": "Оригинальный Safari браузера",
      "data.browser_chromium_version": "Версия Chromium браузера",
      "data.browser_firefox_original": "Оригинальный Firefox браузера",
      "created.timestamp": "Время создания",
    },
    filters: {
      username: {
        label: "Имя пользователя",
      },
    },
  },
  [moduleNames.ADMIN_NEWS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Новости",
    createLabel: "Добавить новость",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать новость",
    editModalTitle: "Редактировать новость",
    editModalBulkTitle: "Редактировать новости",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить новость",
    deleteModalBulkTitle: "Удалить новости",
    columns: {
      "info.id": "ID",
      "data.title": "Заголовок",
      "data.short_description": "Описание",
      "data.category": "Категория",
      "data.status": "Статус",
      "data.created_at": "Создано",
      "info.user_id": "ID пользователя",
      "data.username": "Имя пользователя",
      "data.popup": "Всплывающее окно",
    },
    filters: {
      id: {
        label: "ID",
        description: "Поиск по ID",
      },
      user_id: {
        label: "ID пользователя",
        description: "Поиск по имени пользователя",
      },
      category: {
        label: "Категория",
      },
      status: {
        label: "Статус",
      },
      popup: {
        label: "Всплывающее окно",
        description: "Показывать новость во всплывающем окне",
      },
      automaticDeletionAfter: {
        label: "Автоматическое удаление через"
      },
    },

    formData: {
      title: {
        label: "Заголовок",
        placeholder: "Заголовок новости",
      },
      shortDescription: {
        label: "Краткое описание",
        placeholder: "Описание новости",
      },
      automaticDeletionAfter: {
        label: "Автоматическое удаление через"
      },
      category: {
        label: "Категория",
      },
      status: {
        label: "Статус",
      },
      text: {
        label: "Текст",
      },
      popup: {
        label: "Всплывающее окно",
      },
    },
  },
  [moduleNames.ADMIN_LANDINGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Целевые страницы",
    createLabel: "Добавить целевую страницу",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать целевую страницу",
    editModalTitle: "Редактировать целевую страницу",
    editModalBulkTitle: "Редактировать целевые страницы",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить целевую страницу",
    deleteModalBulkTitle: "Удалить целевые страницы",
    columns: {
      "info.id": "ID",
      "data.name": "Название",
      "data.download_url": "URL загрузки",
      "data.redirect_url": "URL перенаправления",
      "data.status": "Статус",
      "data.category.id": "Категория",
      "data.category_code": "Код страны",
      "info.offer_name": "Название оффера",
      "info.offer_id": "ID оффера",
      "data.country_code": "Название страны",
      "info.user_id": "ID пользователя",
      "info.username": "Имя пользователя",
    },
    filters: {
      id: { label: "Идентификатор", description: "Поиск по идентификатору" },
      offer_id: { label: "Офферы", description: "Поиск по имени" },
      user_id: {
        label: "Имя пользователя",
        description: "Поиск по имени пользователя",
      },
      category_id: { label: "Категория" },
      name: { label: "Имя", description: "Поиск по имени" },
      country_code: { label: "Страна" },
      status: { label: "Статус", description: "Поиск по статусу" },
    },

    formData: {
      offer_id: { label: "Офферы" },
      name: { label: "Имя" },
      category_id: { label: "Категория" },
      country_code: { label: "Страна" },
      status: { label: "Статус" },
      redirect_url: { label: "URL перенаправления" },
      download_url: { label: "URL загрузки" },
      user_id: { label: "Пользователь" },
    },
  },
  [moduleNames.ADMIN_PRELANDINGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Предварительные страницы",
    createLabel: "Добавить предварительную страницу",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать предварительную страницу",
    editModalTitle: "Редактировать предварительную страницу",
    editModalBulkTitle: "Редактировать предварительные страницы",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить предварительную страницу",
    deleteModalBulkTitle: "Удалить предварительные страницы",
    columns: {
      "info.id": "ID",
      "data.name": "Название",
      "data.download_url": "URL загрузки",
      "data.redirect_url": "URL перенаправления",
      "data.status": "Статус",
      "data.category.id": "ID категории",
      "data.category.name": "Название категории",
      "data.county_code": "Код страны",
      "info.offer_name": "Оффер",
      "info.offer_id": "ID оффера",
      "info.country_name": "Название страны",
      "info.user_id": "ID пользователя",
      "info.username": "Имя пользователя",
    },
    filters: {
      id: { label: "ID", description: "Поиск по ID" },
      offer_id: { label: "Оффер", description: "Поиск по названию" },
      user_id: {
        label: "Имя пользователя",
        description: "Поиск по имени пользователя",
      },
      category_id: { label: "Категория" },
      name: { label: "Название", description: "Поиск по названию" },
      country_code: { label: "Страна" },
      status: { label: "Статус", description: "Поиск по статусу" },
    },

    formData: {
      offer_id: { label: "Оффер" },
      name: { label: "Название" },
      category_id: { label: "Категория" },
      country_code: { label: "Страна" },
      status: { label: "Статус" },
      redirect_url: { label: "URL перенаправления" },
      download_url: { label: "URL загрузки" },
      user_id: {
        label: "Пользователь",
        description: "Поиск по имени пользователя",
      },
    },
  },
  [moduleNames.ADMIN_LOGS_QUEUE_EMAIL]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    // browserTabTitle: "MonadLead - Очередь электронной почты",
    columns: {
      id: "ID",
      username: "Имя пользователя",
      email: "Email",
      template: "Шаблон",
      url: "URL",
      file: "Файл",
      status: "Статус",
      executed: "Выполнено",
      created: "Создано",
    },
    filters: {
      template: {
        label: "Шаблон",
        description: "Поиск по шаблону",
      },
      email: {
        label: "Email",
        description: "Поиск по Email",
      },
      username: {
        label: "Имя пользователя",
        description: "Поиск по имени пользователя",
      },
      status: {
        label: "Статус",
        description: "Фильтр по статусу",
      },
    },
  },
  [moduleNames.ADMIN_ORDERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Заказы",
    editLabel: "Редактировать",
    logsLabel: "Логи",
    editBulkLabel: "Редактировать",
    editModalTitle: "Редактировать заказ",
    editModalBulkTitle: "Редактировать заказы",
    reqResModalTitle: "Логи запроса/ответа",
    columns: {
      "info.id": "ID",
      name: "Имя",
      phone: "Телефон",
      "offer.id": "ID оффера",
      "offer.name": "Название оффера",
      "advertiser.offer_id": "ID оффера рекламодателя",
      "info.advertiser_id": "ID рекламодателя",
      "info.advertiser_username": "Рекламодатель",
      "info.status": "Статус",
      "info.before_status": "Предыдущий статус",
      "info.affiliate_id": "ID партнёра",
      "info.affiliate_username": "Партнёр",
      "flow.landings.id": "ID лендинга",
      "flow.landings.name": "Название лендинга",
      "flow.prelandings.id": "ID прелендинга",
      "flow.prelandings.name": "Название прелендинга",
      country_code: "Страна",
      quantity: "Количество",
      "tracking.user_ip": "IP пользователя",
      "created.timestamp": "Создано",
      base_url: "Базовый URL",
      referrer: "Реферрер",
      "tracking.sub_1": "Sub 1",
      "tracking.sub_2": "Sub 2",
      "tracking.sub_3": "Sub 3",
      "tracking.sub_4": "Sub 4",
      "tracking.os_name": "Имя ОС",
      "tracking.os_version": "Версия ОС",
      "tracking.browser_name": "Браузер",
      "tracking.browser_version": "Версия браузера",
      "tracking.safe_id": "Safe ID",
      "tracking.click_id": "ID клика",
      "tracking.device_type": "Тип устройства",
      "tracking.external_id": "Внешний ID",
      "tracking.utm_term": "UTM термин",
      "tracking.utm_medium": "UTM источник",
      "tracking.utm_source": "UTM медиум",
      "tracking.utm_content": "UTM контент",
      "tracking.utm_campaign": "UTM кампания",
      "info.last_update": "Последнее обновление",
      "info.counter": "Счётчик",
      "info.comment": "Комментарий",
      test_mode: "Тестовый режим",


    },
    filters: {
      id: { label: "ID" },

      affiliate_id: { label: "Афф. ID", description: "Поиск по Афф. ID" },
      affiliate_username: { label: "Афф. Имя пользователя", description: "Поиск по Афф. Имени пользователя" },
      affiliate_safe_id: { label: "Афф. SafeId", description: "Поиск по Афф. SafeId" },

      advertiser_id: { label: "Рекл. ID", description: "Поиск по Рекл. ID" },
      advertiser_username: { label: "Рекл. Имя пользователя", description: "Поиск по Рекл. Имени пользователя" },
      advertiser_safe_id: { label: "Рекл. SafeId", description: "Поиск по Рекл. SafeId" },

      country_code: { label: "Страна", description: "Поиск по названию страны" },
      offer_id: { label: "Оффер", description: "Поиск по названию оффера" },
      prelanding_id: { label: "Прелендинг", description: "Поиск по названию" },
      landing_id: { label: "Лендинг", description: "Поиск по названию" },
      tracking_sub_1: { label: "Sub 1" },
      tracking_sub_2: { label: "Sub 2" },
      tracking_sub_3: { label: "Sub 3" },
      tracking_sub_4: { label: "Sub 4" },
      tracking_click_id: { label: "ID клика" },
      name: { label: "Имя" },
      external_id: { label: "Внешний ID" },
      phone: { label: "Номер телефона" },
      status: { label: "Статус" },
      date_range: { label: "Диапазон дат" },
    },
    formData: {
      country_code: {
        label: "Страна",
        description: "Поиск по названию страны",
      },
      name: { label: "Имя" },
      phone: { label: "Телефон" },
      user_ip: { label: "IP пользователя" },
      test_mode: { label: "Тестовый режим" },
      advertiserOfferId: { label: "ID оффера рекламодателя" },
      reset_counter: { label: "Сбросить счётчик" },
    },
  },
  [moduleNames.ADMIN_ORDERS_ERRORS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Ошибки заказов",
    editLabel: "Редактировать",
    deleteLabel: "Удалить",
    resendLabel: "Повторить",
    editBulkLabel: "Редактировать",
    deleteBulkLabel: "Удалить",
    editModalTitle: "Редактировать заказ",
    deleteModalTitle: "Удалить заказ",
    deleteModalBulkTitle: "Удалить заказы",
    editModalBulkTitle: "Редактировать заказы",
    resendModalTitle: "Повторить заказ",
    resendModalBody: "Вы уверены, что хотите повторить этот заказ?",
    columns: {
      "info.id": "ID",
      name: "Имя",
      phone: "Телефон",
      "info.status": "Статус",
      "info.attempts": "Попытки",
      error: "Ошибка",
      offer_id: "ID Офферы",
      base_url: "Базовый URL",
      api_key: "API ключ",
      user_ip: "IP пользователя",
      country_code: "Код страны",
      referrer: "Реферер",
      test_mode: "Тестовый режим",
      os_name: "Название ОС",
      os_version: "Версия ОС",
      browser_version: "Версия браузера",
      device_type: "Тип устройства",
      click_id: "ID клика",
      safe_id: "Безопасный ID",
      sub_1: "Sub 1",
      sub_2: "Sub 2",
      sub_3: "Sub 3",
      sub_4: "Sub 4",
      quantity: "Количество",
      utm_term: "UTM Терм",
      utm_medium: "UTM Средство",
      utm_source: "UTM Источник",
      utm_content: "UTM Контент",
      utm_campaign: "UTM Кампания",
      "info.date": "Дата",
      "info.timestamp": "Созданный"
    },
    filters: {
      name: { label: "Имя" },
      api_key: { label: "API ключ" },
      safe_id: {
        label: "Безопасный ID",
        description: "Поиск по безопасному ID",
      },
      user_ip: {
        label: "IP пользователя",
        description: "Поиск по IP-адресу пользователя",
      },
      offer_id: {
        label: "Офферы",
        description: "Поиск по названию Офферы",
      },
      country_code: {
        label: "Страна",
        description: "Поиск по названию страны",
      },
      click_id: { label: "ID клика" },
      landings: {
        label: "Посадочная страница",
        description: "Поиск по названию посадочной страницы",
      },
      prelandings: { label: "Прелендинг", description: "Поиск по названию" },
    },
    formData: {
      name: { label: "Имя", placeholder: "Имя", description: "Изменить имя" },
      phone: {
        label: "Телефон",
        placeholder: "Телефон",
        description: "Изменить телефон",
      },
      apiKey: {
        label: "API ключ",
        placeholder: "API ключ",
        description: "Изменить API ключ",
      },
      userIp: {
        label: "IP пользователя",
        placeholder: "IP",
        description: "Изменить IP адрес пользователя",
      },
      baseUrl: {
        label: "Базовый URL",
        placeholder: "URL",
        description: "Изменить базовый URL",
      },
      landings: {
        label: "Посадочные страницы",
        placeholder: "Посадочные страницы",
        description: "Выбрать посадочную страницу",
      },
      offerId: {
        label: "ID Офферы",
        placeholder: "ID Офферы",
        description: "Поиск по ID Офферы",
      },
      referrer: {
        label: "Реферер",
        placeholder: "Реферер",
        description: "Изменить ссылку реферера",
      },
      testMode: {
        label: "Тестовый режим",
        placeholder: "Тестовый режим",
        description: "Выбрать режим",
      },
      countryCode: {
        label: "Страна",
        placeholder: "Название страны",
        description: "Поиск по названию страны",
      },
      safeId: {
        label: "Безопасный ID",
        placeholder: "Безопасный ID",
        description: "Изменить безопасный ID",
      },
    },
  },
  [moduleNames.ADMIN_PAYMENTS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Платежи",
    createLabel: "Добавить платеж",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    paymentLabel: "Отметить как оплачено",
    massRequestLabel: "Массовый запрос",
    paymentModalTitle: 'Отметить как оплачено для',
    addModalTitle: "Создать платеж",
    editModalTitle: "Редактировать платеж",
    editModalBulkTitle: "Редактировать платежи",
    paidConfirmationMessage: "Подтвердите, что хотите отметить платеж как оплаченный?",
    massConfirmationMessage: "Вы уверены, что хотите запустить массовые выплаты?",
    massModalTitle: "Массовый запрос",
    columns: {
      "info.id": "ID",
      "info.user_id": "Пользователь",
      "info.username": "Имя пользователя",
      "username-id": "ID - имя пользователя",
      "info.amount": "Сумма",
      "data.method": "Метод",
      "data.payment_settings_id.id": "ID настроек платежа",
      "data.status": "Статус",
      "data.description": "Описание",
      "data.reject_comment": "Комментарий к отказу",
      "info.created_time": "Создано",
    },
    filters: {
      user_id: {
        label: "Пользователь",
        description: "Поиск по имени пользователя",
      },
      method: {
        label: "Метод",
        description: "Поиск по методу",
      },
      status: {
        label: "Статус",
        description: "Поиск по статусу",
      },
    },
    formData: {
      user_id: {
        label: "Пользователь",
        description: "Поиск по имени пользователя",
      },
      amount: {
        label: "Сумма",
        description: "Введите сумму",
      },
      method: {
        label: "Метод",
        description: "Выберите метод платежа",
      },
      status: {
        label: "Статус",
        description: "Выберите статус",
      },
      reject_comment: {
        label: "Комментарий к отказу",
        description: "Введите комментарий к отказу",
      },
      tracking_id: {
        label: "Идентификатор отслеживания",
        description: "Введите идентификатор отслеживания",
      },

    },
  },
  [moduleNames.ADMIN_TOPUPS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Пополнения",
    createLabel: "Добавить пополнение",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать пополнение",
    editModalTitle: "Редактировать пополнение",
    editModalBulkTitle: "Редактировать пополнения",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить пополнение",
    deleteModalBulkTitle: "Удалить пополнения",
    columns: {
      "info.id": "ID",
      "info.username": "Имя пользователя",
      "data.orginal_amount": "Исходная сумма",
      "data.amount": "Сумма",
      "data.invoice_number": "Номер счета",
      "data.invoice_pdf": "Счет в формате PDF",
      "created.timestamp": "Дата создания",
      "created.date": "Создано в",
      "info.advertiser_id": "ID рекламодателя",
    },
    filters: {
      advertiser_id: { label: "Рекламодатель" },
      invoice_number: { label: "Номер счета" },
      amount: { label: "Сумма" },
      orginal_amount: { label: "Исходная сумма" },
    },

    formData: {
      advertiser_id: { label: "Рекламодатель" },
      amount: { label: "Сумма" },
      original_amount: { label: "Исходная сумма" },
      invoice_number: { label: "Номер счета" },
      invoicePdf: { label: "Счет в формате PDF" },
    },
  },
  [moduleNames.ADMIN_USERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Пользователи",
    createLabel: "Добавить пользователя",
    editLabel: "Редактировать",
    required: "Обязательно*",
    info: "Информация",
    message: "Сообщение",
    social: "Социальное",
    company: "Компания",
    paymentLabel: "Платеж",
    authLabel: "Авторизация",
    permissionsLabel: "Права доступа",
    deleteLabel: "Удалить",
    editBulkLabel: "Редактировать",
    deleteBulkLabel: "Удалить",
    createModalTitle: "Создать пользователя",
    editModalTitle: "Редактировать пользователя",
    authModalTitle: "Изменить пароль пользователя",
    permissionModalTitle: "Права доступа пользователя",
    deleteModalTitle: "Удалить пользователя",
    deleteModalBulkTitle: "Удалить пользователей",
    editModalBulkTitle: "Редактировать пользователей",
    emailChangeConfirmation:
      "Изменение email сбросит верификацию аккаунта — на новый адрес будет отправлено письмо для подтверждения, и пользователю нужно будет заново верифицировать аккаунт. Продолжить?",
    emailPermissionNote:
      "Для изменения email-адреса требуется разрешение «Обновить email».",
    emailChangePermissionError:
      "У вас нет разрешения на изменение email-адреса.",
    serverFieldErrors: {
      8: {
        email: "Некорректный email-адрес.",
        password: "Пароль должен содержать от 12 до 128 символов.",
        repeated_password: "Пароли не совпадают.",
      },
      9: { email: "Этот email-адрес уже используется другим пользователем." },
    },
    columns: {
      "info.id": "ID",
      "data.email": "Email",
      "data.username": "Имя пользователя",
      "data.first_name": "Имя",
      "data.last_name": "Фамилия",
      "data.status": "Статус",
      "data.info.type": "Тип",
      "data.info.is_active": "Активный",
      "data.info.is_approved": "Одобренный",
      "data.info.trusted": "Доверенный",
      "data.info.is_anonymous": "Анонимный",
      "data.info.is_worker": "Работник",
      "data.info.is_company": "Компания",
      "data.info.token": "Токен",
      "data.info.api_key": "Ключ API",
      "data.info.safe_id": "ID безопасности",
      "data.info.comment": "Комментарий",
      "data.info.manager_id": "ID менеджера",
      "info.manager_username": "Имя менеджера",
      "data.ref_id": "ID реферрала",
      "data.message.skype": "Skype",
      "data.message.telegram": "Telegram",
      "data.message.whatsapp": "WhatsApp",
      "data.social.google": "Google",
      "data.social.twiter": "Twitter",
      "data.social.facebook": "Facebook",
      "data.social.linkedin": "LinkedIn",
      "data.social.instagram": "Instagram",
      "data.company.name": "Название компании",
      "data.company.email": "Email компании",
      "data.company.city": "Город компании",
      "data.company.zip": "Почтовый индекс компании",
      "data.company.country.code": "Страна компании",
      "data.company.address": "Адрес компании",
      "data.company.tax": "Налог компании",
      "edited.timestamp": "Редактировано",
      "edited.user.id": "Отредактировано пользователем",
      "edited.user.ip": "Редактировано с IP-адреса",
      "created.timestamp": "Создано",
      "created.user.id": "Создано пользователем",
      "created.user.ip": "Создано с IP-адреса",
      "info.refferal_username": "Реферрал",
      "data.country.code": "Страна",
    },
    filters: {
      id: { label: "ID", description: "Поиск по ID" },
      safe_id: { label: "ID безопасности" },
      username: {
        label: "Имя пользователя",
        description: "Поиск по имени пользователя",
      },
      email: { label: "Email", description: "Поиск по email" },
      type: { label: "Тип" },
      country_code: { label: "Страна" },
      manager_id: { label: "Менеджер" },
      status: { label: "Статус" },
      traffic_source: { label: "Источник трафика" },
      message_skype: { label: "Skype" },
      message_telegram: { label: "Telegram" },
      message_whatsapp: { label: "WhatsApp" },
      api_key: { label: "Ключ API" },
    },

    formData: {
      username: { label: "Имя пользователя" },
      firstName: { label: "Имя" },
      lastName: { label: "Фамилия" },
      email: { label: "Email" },
      status: { label: "Статус" },
      manager: { label: "Менеджер" },
      password: { label: "Пароль" },
      repeatPassword: { label: "Повторите пароль" },
      comment: { label: "Комментарий" },
      type: { label: "Тип" },
      country: { label: "Страна", description: "Поиск по названию страны" },
      referral: { label: "Реферрал" },
      isActive: { label: "Активный" },
      isApproved: { label: "Одобренный" },
      trusted: { label: "Доверенный" },
      isAnonymous: { label: "Анонимный" },
      isWorker: { label: "Работник" },
      isCompany: { label: "Компания" },
      skype: { label: "Skype" },
      telegram: { label: "Telegram" },
      whatsapp: { label: "WhatsApp" },
      google: { label: "Google" },
      twitter: { label: "Twitter" },
      facebook: { label: "Facebook" },
      linkedin: { label: "LinkedIn" },
      instagram: { label: "Instagram" },
      companyName: { label: "Название компании" },
      companyEmail: { label: "Email компании" },
      companyCity: { label: "Город компании" },
      companyZip: { label: "Почтовый индекс компании" },
      companyCountry: {
        label: "Страна",
        description: "Поиск по названию страны",
      },
      companyAddress: { label: "Адрес компании" },
      companyTax: { label: "Налог компании" },
      traffic_source: { label: "Источник трафика" },

    },
  },
  [moduleNames.ADMIN_USERS_UNAPPROVED]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Неодобренные пользователи",
    approveLabel: "Одобрить",
    setManagerLabel: "Назначить менеджера",
    resetManagerLabel: "Сбросить менеджера",
    rejectLabel: "Отклонить",
    rejectBulkLabel: "Отклонить",
    rejectModalTitle: "Отклонить пользователя",
    rejectModalBulkTitle: "Отклонить пользователей",
    approveModalTitle: "Одобрить пользователя",
    approveModalBody: "Вы уверены, что хотите одобрить пользователя?",
    setManagerModalTitle: "Назначить менеджера",
    setManagerModalBody:
      "Вы уверены, что хотите назначить менеджера для пользователя?",
    resetManagerModalTitle: "Сбросить менеджера",
    resetManagerModalBody:
      "Вы уверены, что хотите сбросить менеджера для пользователя?",
    columns: {
      "info.id": "ID",
      "data.email": "Email",
      "data.username": "Имя пользователя",
      "data.first_name": "Имя",
      "data.last_name": "Фамилия",
      "data.info.comment": "Комментарий",
      "data.message.skype": "Skype",
      "data.message.telegram": "Telegram",
      "data.message.whatsapp": "WhatsApp",
      "data.status": "Статус",
      "data.info.type": "Тип",
      "data.info.is_active": "Активный",
      "data.info.is_approved": "Одобренный",
      "data.info.trusted": "Доверенный",
      "data.info.is_anonymous": "Анонимный",
      "data.info.is_worker": "Работник",
      "data.info.is_company": "Компания",
      "created.timestamp": "Время создания",
    },
    filters: {
      id: { label: "ID", description: "Поиск по ID" },
      safe_id: { label: "Safe ID" },
      username: {
        label: "Имя пользователя",
        description: "Поиск по имени пользователя",
      },
      email: { label: "Email", description: "Поиск по email" },
      type: { label: "Тип" },
      country_code: { label: "Страна" },
      status: { label: "Статус" },
    },

    formData: {
      rejectComment: { label: "Комментарий отклонения" },
    },
  },
  [moduleNames.ADMIN_POSTBACK_LOGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Логи постбеов",
    columns: {
      "info.id": "ID",
      "info.username": "Имя пользователя",
      "data.offer.name": "Название оффера",
      "data.request_url": "URL запроса",
      "data.status": "Статус",
      "data.response_code": "HTTP статус",
      "data.offer_id": "ID оффера",
      "info.user_id": "ID пользователя",
      "info.timestamp": "Отметка времени",
    },
    filters: {
      id: {
        label: "ID",
        description: "Поиск по ID",
      },
      user_id: {
        label: "Имя пользователя",
        description: "Поиск по имени пользователя",
      },
      offer_id: {
        label: "Оффер",
        description: "Поиск по офферу",
      },
      response_code: {
        label: "HTTP статус",
        description: "Поиск по HTTP статусу",
      },
      status: {
        label: "Статус",
        description: "Поиск по статусу",
      },
      date_range: {
        label: "Диапазон дат",
        description: "Выберите диапазон дат",
      },
    },
  },
  [moduleNames.ADMIN_PROFILE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    serverFieldErrors: profileServerFieldErrors,
    browserTabTitle: "MonadLead - Профиль",
    saveChanges: "Сохранить изменения",
    deleteSessionsTitle: "Удалить сеансы?",
    deleteSessionsDialog: "Вы уверены, что хотите удалить все сеансы?",
    osName: "Имя ОС",
    osTitle: "Название ОС",
    createdAt: "Дата создания",
    expires: "Истекает",
    browserName: "Браузера",
    deviceType: "Тип устройства",
    generalTitle: 'Общие настройки профиля',
    changePasswordTitle: 'Настройки аутентификации профиля',
    messagesTitle: 'Настройки мгновенных сообщений профиля',
    companyTitle: 'Настройки компании профиля',
    profileSettingsOptions: {
      general: "Общее",
      changePassword: "Изменить пароль",
      changePin: "Изменить ПИН-код",
      social: "Социальные",
      messages: "Сообщения",
      company: "Компания",
      sessions: "Сеансы",
      delete_session: "Удалить сеанс?",
      delete_confirmation: "Вы уверены, что хотите удалить этот сеанс?",
      delete: "Удалить",
      cancel: "Отмена",
    },
    helperText: {
      general: "Внесите свои общие пресональные данные",
      changePassword:
        "Если вы потеряли пароль или хотите изменить его, заполните форму ниже, написав свой новый пароль и повторив его.",
      changePin:
        "После истечения срока вашей сессии, используйте PIN-код вместо пароля для быстрого входа. Измените PIN-код, используя форму ниже.",
      social:
        "Вставьте ссылки на профили в социальных сетях, которыми вы пользуетесь в настоящее время.",
      messages:
        "Вставьте ссылки на профили в социальных сетях, которыми вы пользуетесь в настоящее время.",
      company:
        "Для регистрации вашей компании, пожалуйста, предоставьте правильную общую информацию.",
    },
    generalSettings: {
      firstName: { label: "Имя" },
      lastName: { label: "Фамилия" },
      chooseCountry: { label: "Выберите страну" },
    },
    changePasswordSettings: {
      password: { label: "Пароль" },
      repeatPassword: { label: "Повторите пароль" },
    },
    changePinSettings: {
      pin: { label: "Пин-код" },
      repeatPin: { label: "Повторите пин-код" },
    },
    socialSettings: {
      facebook: {
        label: "Ссылка на профиль Facebook",
        placeholder: "Ссылка на профиль Facebook",
      },
      google: {
        label: "Ссылка на профиль Google",
        placeholder: "Ссылка на профиль Google",
      },
      twitter: {
        label: "Ссылка на профиль Twitter",
        placeholder: "Ссылка на профиль Twitter",
      },
      linkedin: {
        label: "Ссылка на профиль Linkedin",
        placeholder: "Ссылка на профиль Linkedin",
      },
      instagram: {
        label: "Ссылка на профиль Instagram",
        placeholder: "Ссылка на профиль Instagram",
      },
    },
    messageSettings: {
      skype: { label: "Skype", placeholder: "Ссылка на профиль Skype" },
      telegram: { label: "Telegram", placeholder: "Telegram" },
      whatsapp: { label: "Whatsapp", placeholder: "Номер телефона Whatsapp" },
    },
    companySettings: {
      companyName: {
        label: "Название компании",
        placeholder: "Название компании",
      },
      country: { label: "Страна", placeholder: "Выберите страну" },
      city: { label: "Город", placeholder: "Город" },
      address: { label: "Адрес", placeholder: "Адрес" },
      zipCode: { label: "Почтовый индекс", placeholder: "Почтовый индекс" },
      companyEmail: {
        label: "Электронная почта компании",
        placeholder: "Электронная почта компании",
      },
      tax: { label: "Налог", placeholder: "Налог" },
    },
    sessions: {
      setSessionExpirationTitle: "Установить срок действия сеанса",
      expiration: {
        label: "Срок действия",
        days: {
          oneDay: "1 день",
          sevenDays: "7 дней",
          fifteenDays: "15 дней",
          thirtyDays: "30 дней",
          ninetyDays: "90 дней",
        },
      },
      activeSessionsTitle: "Активные сеансы",
      closeAllSessions: "Закрыть все сеансы",
    },
    formData: {
      firstName: { label: "Имя" },
      lastName: { label: "Фамилия" },
      password: { label: "Пароль" },
      repeatPassword: { label: "Повторите пароль" },
      pin: { label: "Пин-код" },
      repeated_pin: { label: "Повторите пин-код" },
      country: {
        label: "Страна",
        description: "Поиск по названию страны"
      },
      skype: { label: "Скайп" },
      telegram: { label: "Телеграм" },
      whatsapp: { label: "Вотсап" },
      companyName: { label: "Название" },
      companyEmail: { label: "Email" },
      companyCity: { label: "Город" },
      companyZip: { label: "Почтовый индекс" },
      companyAddress: { label: "Адрес" },
      companyTax: { label: "Налог" },
      companyCountry: {
        label: "Страна",
        description: "Поиск по названию страны"
      },
    }

  },
  [moduleNames.ADMIN_FAQ]: {
    browserTabTitle: 'MonadLead - Часто задаваемые вопросы',
    title: 'Советы и ответы от команды MonadLead',
    apiSettingsTitle: 'Настройки API',
    apiSettingsSubtitle: 'Узнайте, как интегрировать вашу лендинг-страницу с MonadLead',
    postbackSettingsTitle: 'Настройки постбэка',
    postbackSettingsSubtitle: 'Поймите, как настроить постбэки для конверсий',
    introVideoTitle: 'Вводное видео',
    introVideoSubtitle: 'Посмотрите краткое введение в нашу платформу',
    videoNotSupported: 'Ваш браузер не поддерживает тег видео.',
    backToFaq: 'Назад к Часто задаваемые вопросы',
    apiSettings: {
      question1: 'Какие поля обязательны для интеграции API?',
      answer1: 'Для правильного подключения вашей лендинг-страницы к MonadLead через API обязательны следующие поля:',
      question2: 'Как подключить лендинг-страницу к MonadLead через API?',
      answer2: `Для подключения лендинг-страницы к MonadLead через API вы можете использовать шаблон файла интеграции, предоставленный вашим менеджером. Обновите файл с вашим API_KEY, настройте форму на перенаправление к этому файлу, и всё готово.`,
      question3: 'Как скачать лендинг-страницы из MonadLead?',
      answer3: 'Вы можете скачать лендинг-страницы со страницы оффера, нажав кнопку Скачать на карточке нужной лендинг-страницы.',
      question4: 'Если я скачал лендинг-страницу из MonadLead, она уже настроена?',
      answer4: 'Да. Когда вы скачиваете лендинг-страницу из MonadLead, все API-настройки уже сконфигурированы, и ваш API_KEY заполнен заранее. Всё, что нужно — разместить её на хостинге.',
    },
    postbackSettings: {
      question1: 'Какие макросы обязательны?',
      answer1: 'В MonadLead нет обязательных макросов. Вы настраиваете макросы согласно требованиям вашего трекера и вашим нуждам отслеживания.',
      question2: 'Что такое глобальный и специфический постбэк и какой выбрать?',
      answer2_1: 'Глобальный постбэк срабатывает каждый раз, когда выполняются его условия, независимо от оффера, с которого пришла конверсия.',
      answer2_2: 'Специфический постбэк привязан к конкретному офферу и срабатывает только для него.',
      answer2_3: 'Используйте специфический постбэк, если у вас особые сценарии и нужно отправлять постбэки только для одного оффера.',
      answer2_4: 'Во всех остальных случаях рекомендуется глобальный постбэк, так как он работает для всех офферов.',
    }
  },

  [moduleNames.ADMIN_PRELANDINGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Прелендинги",
    createLabel: "Добавить предварительную загрузку",
    editLabel: "Изменить",
    editBulkLabel: "Изменить",
    addModalTitle: "Создать предварительную загрузку",
    editModalTitle: "Изменить предварительную загрузку",
    editModalBulkTitle: "Изменить предварительные загрузки",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить предварительную загрузку",
    deleteModalBulkTitle: "Удалить предварительные загрузки",
    columns: {
      "info.id": "ID",
      "data.name": "Название",
      "data.download_url": "URL загрузки",
      "data.redirect_url": "URL перенаправления",
      "data.status": "Статус",
      "data.category.id": "Категория",
      "data.category.name": "Название категории",
      "data.country_code": "Страна",
      "info.offer_name": "Оффер",
      "info.offer_id": "ID оффера",
      "info.country_name": "Название страны",
      "info.user_id": "ID пользователя",
      "info.username": "Имя пользователя",
    },
    filters: {
      id: { label: "ID", description: "Поиск по ID" },
      offer_id: { label: "Оффер", description: "Поиск по названию" },
      user_id: {
        label: "Имя пользователя",
        description: "Поиск по имени пользователя",
      },
      category_id: { label: "Категория" },
      name: { label: "Название", description: "Поиск по названию" },
      country_code: { label: "Страна" },
      status: { label: "Статус", description: "Поиск по статусу" },
    },
    formData: {
      offer_id: { label: "Оффер" },
      name: { label: "Название" },
      category_id: { label: "Категория" },
      country_code: { label: "Страна" },
      status: { label: "Статус" },
      redirect_url: { label: "URL перенаправления" },
      download_url: { label: "URL загрузки" },
      user_id: {
        label: "Пользователь",
        description: "Поиск по имени пользователя",
      },
    },
  },

  [moduleNames.AFFILIATE_DOMAINS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Домены",
    createLabel: "Добавить домен",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать домен",
    editModalTitle: "Редактировать домен",
    editModalBulkTitle: "Редактировать домены",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить домен",
    deleteModalBulkTitle: "Удалить домены",
    contactSupport:
      "Пожалуйста, свяжитесь с нашей службой поддержки, и они предоставят вам IP-адрес для записи A.",
    columns: {
      "info.id": "ID",
      "data.domain": "Домен",
      "data.type": "Тип",
      "data.status": "Статус",
    },
    filters: {
      id: { label: "ID", description: "Поиск по ID" },
      status: { label: "Статус", description: "Поиск по статусу" },
      type: { label: "Тип", description: "Поиск по типу" },
    },
    formData: {
      domain: {
        label: "Домен",
        description: "Введите имя домена",
        placeholder: "Добавить домен",
      },
      type: {
        label: "Тип",
        placeholder: "Отслеживание...",
        description: "Выберите тип домена",
      },
      status: {
        label: "Статус",
        placeholder: "Активный...",
        description: "Установить статус",
      },
    },
  },
  [moduleNames.AFFILIATE_PAYMENTS_REQUEST]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Запросы на выплату",
    createLabel: "Запросить выплату",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Запросить выплату",
    editModalTitle: "Редактировать запрос на выплату",
    editModalBulkTitle: "Редактировать запросы на выплату",
    columns: {
      "info.id": "ID",
      "data.payment_settings_id": "Настройки оплаты",
      "info.amount": "Сумма",
      "data.method": "Метод",
      "data.status": "Статус",
      "data.description": "Описание",
      "data.reject_comment": "Комментарий к отказу",
      "created.timestamp": "Создано",
      "created.user.id": "Создано пользователем",
      "created.user.ip": "Создано с IP",
      "edited.timestamp": "Отредактировано",
      "edited.user.id": "Отредактировано пользователем",
      "edited.user.ip": "Отредактировано с IP",
    },
    filters: {
      id: { label: "ID", description: "Поиск по ID" },
      status: { label: "Статус" },
      method: { label: "Метод" },
    },
    formData: {
      method: { label: "Метод", placeholder: "Запрос на выплату" },
      amount: { label: "Сумма" },
      payment_settings_id: { label: "Настройки оплаты" },
    },
  },
  [moduleNames.AFFILIATE_PAYMENTS_SETTINGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Настройки выплат",
    title: "Существующие методы выплат",
    createLabel: "Добавить новый метод выплаты",
    editLabel: "Редактировать",
    addModalTitle: "Создать настройки выплат",
    editModalTitle: "Редактировать настройки выплат",
    deleteModalTitle: "Удалить метод выплаты?",
    deleteModalBody: "Вы уверены, что хотите удалить {name} ({method})? Это действие нельзя отменить.",
    deleteSuccessMessage: "Метод выплаты удалён",
    activateModalTitle: "Активировать метод выплаты",
    activateModalBody: "Это действие установит метод выплаты в статус активный",
    deactivateModalTitle: "Деактивировать метод выплаты",
    deactivateModalBody:
      "Это действие установит метод выплаты в статус неактивный",
    formData: {
      name: { label: "Название" },
      status: { label: "Статус" },
      method: { label: "Метод", placeholder: "Запрос выплаты" },
      wallet: { label: "Кошелек" },
    },
    confirmationModalTitle: 'Ваш способ оплаты был успешно сохранён',
    confirmationModalMessage: 'Мы отправили письмо с подтверждением на ваш зарегистрированный адрес электронной почты. Пожалуйста, проверьте ваш почтовый ящик и следуйте инструкциям в письме, чтобы завершить процесс. Если вы не видите письмо, проверьте папку Спам или Нежелательная почта.',
  },
  [moduleNames.AFFILIATE_POSTBACK]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Постбеки",
    createLabel: "Добавить постбэк",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать постбэк",
    editModalTitle: "Редактировать постбэк",
    editModalBulkTitle: "Редактировать постбэки",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить постбэк",
    deleteModalBulkTitle: "Удалить постбэки",
    enterUrl: "Введите URL",
    urlParams: "Параметры URL",
    addParams: "Добавить параметры",
    columns: {
      "info.id": "ID",
      "data.name": "Имя",
      "data.url": "URL",
      "data.level": "Уровень",
      "data.method": "Метод",
      "data.event": "Событие",
      "data.status": "Статус",
      "data.offer.name": "Название Офферы",
      "data.offer.id": "ID Офферы",
      "data.user_id": "ID пользователя",
    },
    filters: {
      offer_id: { label: "Офферы", description: "Поиск по oфферы" },
      event: { label: "Событие", description: "Поиск по событию" },
      method: { label: "Метод", description: "Поиск по методу" },
      level: { label: "Уровень", description: "Поиск по уровню" },
    },
    formData: {
      event: {
        label: "Событие",
        placeholder: "Событие",
        rules: { required: "обязательное" },
      },
      level: {
        label: "Уровень",
        placeholder: "Уровень",
        description: "Выберите уровень",
        rules: { required: "обязательное" },
      },
      status: {
        label: "Статус",
        placeholder: "Статус",
        rules: { required: "обязательное" },
      },
      offer_id: {
        label: "Офферы",
        description: "Поиск по названию oфферы",
        rules: { required: "обязательное" },
      },
      method: {
        label: "Метод",
        placeholder: "Метод",
        description: "Выберите метод",
        rules: { required: "обязательное" },
      },
      name: {
        label: "Имя",
        placeholder: "Имя",
        description: "Введите имя",
        rules: { required: "обязательное" },
      },
      url: {
        label: "URL",
        placeholder: "https://domain.com/...",
        description: "Введите URL",
        rules: { required: "обязательное" },
      },
    },
  },
  [moduleNames.AFFILIATE_POSTBACK_LOGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Логи постбэков",
    columns: {
      "info.id": "ID",
      "data.offer.name": "Название Офферы",
      "data.request_url": "URL запроса",
      "data.status": "Статус",
      "data.response_code": "HTTP-статус",
      "data.offer_id": "ID Oфферы",
      "info.timestamp": "Отметка времени",
    },
    filters: {
      id: { label: "ID", description: "Поиск по ID" },
      offer_id: { label: "Офферы", description: "Поиск по oфферы" },
      status: { label: "Статус", description: "Поиск по статусу" },
      date_range: { label: "Диапазон дат" },
    },
  },
  [moduleNames.AFFILIATE_OFFERS_ALL]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    remove: "Удалить из избранного",
    add: "Добавить в избранное",
    country: "Страна",
    price: "Цена",
    payout: "Выплата",
    limit: "Лимит",
    filter: "Фильтры",
    info: "Информация",
    id: "ID",
    viewOfferLabel: "Посмотреть предложение",
    browserTabTitle: "MonadLead - Все предложения",
    columns: {
      "info.id": "Идентификатор",
      "data.name": "Название",
      "data.access": "Доступ",
      "data.status": "Статус",
      "data.paid_status": "Оплаченный статус",
      "data.info.ar": "Показатель одобрения",
      "data.info.cr": "Коэффициент конверсии",
      "data.info.epc": "Заработок с клика",
      "data.advertiser.id": "ID рекламодателя",
      "data.advertiser.name": "Рекламодатель",
      "data.advertiser.offer_id": "ID oфферы рекламодателя",
      "data.category.id": "Категория",
      "data.advertiser.expected_ar":
        "Ожидаемый показатель одобрения рекламодателя",
      "data.main_country_code": "Основная страна",
      "data.advertiser.advertiser_guarantees": "Гарантии рекламодателя",
      "data.advertiser.guaranteed_ar":
        "Гарантированный показатель одобрения рекламодателя",
      "data.advertiser.min_orders":
        "Минимальное количество заказов по гарантии рекламодателя",
      "data.advertiser.timeframe":
        "Временной промежуток гарантии рекламодателя",
      "data.device": "Устройство",
      "data.vertical": "Вертикаль",
      "data.region": "Регион",
      "data.flow": "Flow",
      "data.monadlead_tokens": "Токены MonadLead",
      "info.affiliate_payout": "Выплата",
      "info.advertiser_cost": "Расходы",
      "info.payouts": "Цена",
      "info": "Выплата"
    },
    filters: {
      id: { label: "ID", description: "Поиск по ID" },
      name: { label: "Название" },
      advertiser_id: {
        label: "ID рекламодателя",
        description: "Поиск по ID рекламодателя",
      },
      category_id: { label: "Категория" },
      vertical: { label: "Вертикаль" },
      region_id: { label: "Регион" },
      is_favorite: {
        label: "Избранное",
        description: "Поиск по избранному",
      },
      access: { label: "Доступ" },
      paid_status: { label: "Статус оплаты" },
      main_country_code: { label: "Основная страна" },
    },
  },
  [moduleNames.AFFILIATE_OFFERS_HOT]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Топ oфферы",
    removeFromFavorites: "Удалить из избранного",
    addToFavorites: "Добавить в избранное",
    country: "Страна",
    price: "Цена",
    payout: "Выплата",
    limit: "Лимит",
    info: "Информация",
    filters: {
      id: { label: "ID", description: "Поиск по ID" },
      name: { label: "Имя" },
      paid_status: { label: "Статус оплаты" },
      main_country_code: { label: "Основная страна" },
    },
  },
  [moduleNames.AFFILIATE_OFFERS_SINGLE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Одиночные Офферы",
    searchCountry: "Поиск страны",
    info: "Информация",
    id: "ID",
    sub_1: "Sub 1",
    sub_1_placeholder: "Введите Sub 1",
    sub_2: "Sub 2",
    sub_2_placeholder: "Введите Sub 2",
    sub_3: "Sub 3",
    sub_3_placeholder: "Введите Sub 3",
    sub_4: "Sub 4",
    sub_4_placeholder: "Введите Sub 4",
    enter_gtag: "Требуется лединг",
    lp_required: "Требуется лединг",
    gtag: "Google тег",
    enter_fb_pixel: "Введите пиксель Facebook",
    fb_pixel: "Пиксель Facebook",
    body_params: "Параметры тела запроса",
    example: "Пример запроса",
    response_200: "Код ответа 200",
    response_400: "Код ответа 400",
    response_405: "Код ответа 405",
    response_406: "Код ответа 406",
    response_500: "Код ответа 500",
    plp: "Прелендинги",
    lp: "Лендинги",
    conversion_rate: "CR%",
    flow: "Flow",
    countries: "Страны",
    country: "Страна",
    price: "Цена",
    payout: "Выплата",
    limit: "Лимит",
    no_data: "Нет данных",
    link_builder: "Конструктор интеграции",
    form_builder: "Конструктор форм",
    form_preview: "Предпросмотр формы",
    api_request: "Запрос API",
    api_response: "Ответ API",
    request_vip: "Запросить VIP-доступ",
    vip_message:
      "Это VIP-Офферы, и вам необходимо получить доступ, чтобы его рекламировать.",
    request_message:
      "Пожалуйста, дайте нам знать, почему мы должны предоставить вам доступ",
    request_access: "Запросить доступ",
    offer_url: "URL Оффера",
    pages: "Страницы",
    copy: "Копировать",
    no_prelanding: "Нет предварительной страницы",
    open_link: "Открыть в новой вкладке",
    download_file: 'Скачать файл',
    copyLink: 'URL скопирован в буфер обмена',
    copyTooltip: "Скопировать URL",
    noTrackingLinks: "Нет ссылок для отслеживания",

  },
  [moduleNames.AFFILIATE_OFFERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Предложения",
    filters: {
      id: { label: "ID", description: "Поиск по ID" },
      name: { label: "Название" },
      advertiser_id: {
        label: "ID рекламодателя",
        description: "Поиск по ID рекламодателя",
      },
      category_id: { label: "Категория" },
      vertical_id: { label: "Вертикаль" },
      is_favorite: {
        label: "Избранное",
        description: "Поиск по избранному",
      },
      access: { label: "Доступ" },
      paid_status: { label: "Статус оплаты" },
      main_country_code: { label: "Основная страна" },
    },
  },
  [moduleNames.AFFILIATE_OFFERS_SUBSCRIPTIONS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Подписки",
    editLabel: "Редактировать",
    logsLabel: "Логи",
    editBulkLabel: "Редактировать",
    editModalTitle: "Редактировать заказ",
    editModalBulkTitle: "Редактировать заказы",
    payments: "Платежи",
    columns: {
      id: "ID",
      "affiliate.id": "ID аффилиата",
      "affiliate.name": "Аффилиат",
      "offer.id": "ID предложения",
      "offer.name": "Название предложения",
      "advertiser.id": "ID рекламодателя",
      "tracking_link.name": "Трекинговая ссылка",
      "tracking_link.id": "ID трекинговой ссылки",
      rev_share: "Доля дохода",
      subscriber: "Подписчик",
      status: "Статус",
    },
    filters: {
      "offer.name": { label: "Предложение", description: "Поиск по названию предложения" },
      "affiliate.name": { label: "Аффилиат", description: "Поиск по имени аффилиата" },
      "advertiser.id": { label: "ID рекламодателя", description: "Поиск по ID рекламодателя" },
      status: { label: "Статус" },
    },
    formData: {
      rev_share: { label: "Доля дохода" },
      expiration_date: { label: "Дата окончания" },
      status: { label: "Статус" },
    },
  },
  [moduleNames.AFFILIATE_OFFERS_SUBSCRIPTIONS_PAYMENTS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    moduleTitle: "Выплаты",
    createLabel: "Добавить выплату",
    editLabel: "Редактировать",
    editBulkLabel: "Редактировать",
    addModalTitle: "Создать выплату",
    editModalTitle: "Редактировать выплату",
    editModalBulkTitle: "Редактировать выплаты",
    deleteLabel: "Удалить",
    deleteBulkLabel: "Удалить",
    deleteModalTitle: "Удалить выплату",
    deleteModalBulkTitle: "Удалить выплаты",
    columns: {
      description: 'Описание',
      amount: 'Сумма',
      rev_share: 'Доля от выручки',
      status: 'Статус',
    },
    filters: {
      status: { label: "Статус" },
    },
    formData: {

    },

  },
  [moduleNames.AFFILIATE_DASHBOARD]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Панель управления",
    yesterday: "Вчера",
    current_month: "Текущий месяц",
    last_month: "Прошлый месяц",
    today: "Сегодня",
    country: "Страна",
    click: "Клик",
    unique_click: "Уникальный клик",
    revenue: "Доход",
    conversion: "Конверсия",
    conversion_rate: "Коэффициент конверсии",
    rate: "Коэффициент конверсии",
    switch_view: "Сменить вид",
    cr: "CR",
    name: "Имя",
    hold: "Холд",
    event: "Событие",
    trash: "Корзина",
    total: "Всего",
    canceled: "Отменено",
    confirmed: "Подтверждено",
    no_data: "Нет данных",
    statistics: "Статистика",
    click_to_lp: "Клик на LP",
    click_to_prelp: "Клик на PreLP",
    date: "Дата добавления",
    news: "Новости",
    rangeShortcuts: {
      today: "Сегодня",
      yesterday: "Вчера",
      thisWeek: "Эта неделя",
      lastWeek: "Прошлая неделя",
      last7Days: "Последние 7 дней",
      currentMonth: "Текущий месяц",
      lastMonth: "Прошлый месяц",
      selectDate: "ВЫБРАТЬ ДИАПАЗОН ДАТ",
      cancelButton: "Отмена",
      clearButton: "Очистить",
      dateFrom: "Дата начала",
      dateTo: "Дата окончания",
    },

    columns: {
      "info.id": "ID",
      "data.name": "Название",
      "data.download_url": "URL загрузки",
      "data.redirect_url": "URL перенаправления",
      "data.status": "Статус",
      "data.category.id": "Категория",
      "data.category.name": "Название категории",
      "data.country_code": "Страна",
      "info.offer_name": "Офферы",
      "info.offer_id": "ID Офферы",
      "info.country_name": "Название страны",
      "info.user_id": "ID пользователя",
      "info.username": "Имя пользователя",
    },
    filters: {
      id: { label: "ID", description: "Поиск по ID" },
      offer_id: { label: "Офферы", description: "Поиск по имени" },
      user_id: {
        label: "Имя пользователя",
        description: "Поиск по имени пользователя",
      },
      category_id: { label: "Категория" },
      name: { label: "Название", description: "Поиск по названию" },
      country_code: { label: "Страна" },
      status: { label: "Статус", description: "Поиск по статусу" },
    },
    formData: {
      offer_id: { label: "Офферы" },
      name: { label: "Название" },
      category_id: { label: "Категория" },
      country_code: { label: "Страна" },
      status: { label: "Статус" },
      redirect_url: { label: "URL перенаправления" },
      download_url: { label: "URL загрузки" },
      user_id: {
        label: "Пользователь",
        description: "Поиск по имени пользователя",
      },
    },
  },
  [moduleNames.AFFILIATE_REPORT]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Отчет",
    columns: {
      click: "Клики",
      unique_click: "Уникальные клики",
      click_to_prelp: "Клик на prelp",
      click_to_lp: "Клик на lp",
      total_hold: "Всего",
      offer_name: "[ID] - Офферы",
      hold: "В холде",
      date: "Дата",
      day_of_week: "День недели",
      time: "Время",
      hour_of_day: "Час дня",
      sub_1: 'Sub 1',
      sub_2: 'Sub 2',
      sub_3: 'Sub 3',
      sub_4: 'Sub 4',
      device_type: "Тип устройства",
      browser_name: "браузер",
      browser_version: "версия браузера",
      os_name: "имя ОС",
      os_version: "версия OC",
      landings: "Лендинга",
      prelandings: "Прелендинга",
      country_code: "Страна",
      month: "Месяц",
      completed_hold: "Завершенное удержание",
      conversion: "Конверсия",
      conversion_rate: "CR",
      total_trash: "В Треше",
      total_canceled: "Отменено",
      total_hold_revenue: "Общий доход от удержания",
      hold_revenue: "Доход от удержания",
      revenue: "Доход",
      total_trash_revenue: "Общий доход от мусора",
      total_canceled_revenue: "Общий доход от отмены",
      revenue_per_click_hold: "Доход с клика - удержание",
      revenue_per_click_conversion: "Доход с клика - конверсия",
      revenue_per_unique_click_conversion:
        "Доход с уникального клика - конверсия",
      revenue_per_unique_click_hold: "Доход с уникального клика - удержание",
      event: "События",
      utm_source: 'Источник UTM',
      utm_medium: 'Канал UTM',
      utm_campaign: 'Кампания UTM',
      utm_term: 'Ключевое слово UTM',
      utm_content: 'Контент UTM',
    },
    filters: {
      stats_based_on: { label: "Группировать по" },
      offers: { label: "Офферы", description: "Поиск по названию" },
      click_id: { label: "Идентификатор клика" },
      landings: { label: "Целевые страницы" },
      prelandings: { label: "Промежуточные страницы" },
      country_code: { label: "Страна" },
      sub_1: { label: "Sub 1" },
      sub_2: { label: "Sub 2" },
      sub_3: { label: "Sub 3" },
      sub_4: { label: "Sub 4" },
      utm_campaign: { label: "UTM кампания", description: "Поиск по UTM кампании" },
      utm_content: { label: "UTM контент", description: "Поиск по UTM контенту" },
      utm_medium: { label: "UTM канал", description: "Поиск по UTM каналу" },
      utm_source: { label: "Источник UTM", description: "Поиск по источнику UTM" },
      utm_term: { label: "UTM ключевое слово", description: "Поиск по UTM ключевому слову" },
      date_range: { label: "Диапазон дат" },
    },
  },

  [moduleNames.AFFILIATE_ORDERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Заказы",
    columns: {
      "info.id": "ID",
      name: "Название",
      phone: "Телефон",
      "offer.id": "ID Офферы",
      "offer.name": "Oффер",
      "info.status": "Статус",
      "info.before_status": "Предыдущий статус",
      "flow.landings.id": "ID Лендинга",
      "flow.landings.name": "Название лендинга",
      "flow.prelandings.id": "ID Прелендинга",
      "flow.prelandings.name": "Название прелендинга",
      country_code: "Страна",
      quantity: "Количество",
      "tracking.user_ip": "IP пользователя",
      "created.timestamp": "Создано",
      base_url: "Базовый URL",
      referrer: "Реферер",
      "tracking.sub_1": "Sub 1",
      "tracking.sub_2": "Sub 2",
      "tracking.sub_3": "Sub 3",
      "tracking.sub_4": "Sub 4",
      "tracking.os_name": "Название ОС",
      "tracking.os_version": "Версия ОС",
      "tracking.browser_name": "Название браузера",
      "tracking.browser_version": "Версия браузера",
      "tracking.safe_id": "Safe ID",
      "tracking.click_id": "ID клика",
      "tracking.device_type": "Тип устройства",
      "tracking.external_id": "Внешний ID",
      "tracking.utm_term": "UTM Термин",
      "tracking.utm_medium": "UTM Источник",
      "tracking.utm_source": "UTM Медиум",
      "tracking.utm_content": "UTM контент",
      "tracking.utm_campaign": "UTM кампания",
      "info.last_update": "Последнее обновление",
      "info.counter": "Счетчик",
      "info.comment": "Комментарий",
      test_mode: "Тестовый режим",
    },
    filters: {
      id: { label: "ID" },
      country_code: {
        label: "Страна",
        description: "Поиск по названию страны",
      },
      offer_id: { label: "Офферы", description: "Поиск по oфферы" },
      sub_1: { label: "Sub 1", description: "Поиск по Sub 1" },
      sub_2: { label: "Sub 2", description: "Поиск по Sub 2" },
      sub_3: { label: "Sub 3", description: "Поиск по Sub 3" },
      sub_4: { label: "Sub 4", description: "Поиск по Sub 4" },
      click_id: { label: "ID клика", description: "Поиск по ID клика" },
      name: { label: "Имя" },
      external_id: { label: "Внешний ID", description: "Поиск по внешнему ID" },
      phone: { label: "Номер телефона" },
      status: { label: "Статус" },
      prelanding_name: {
        label: "Прелендинг",
        description: "Поиск по прелендингам",
      },
      landing_name: { label: "Лендинг", description: "Поиск по лендингам" },
      date_range: { label: "Диапазон дат" },
    },
  },
  [moduleNames.AFFILIATE_BALANCE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Баланс",
    columns: {
      "info.id": "ID",
      "data.offer_name": "Название oфферы",
      "data.payout": "Выплата",
      "data.click_id": "ID клика",
    },
    filters: {
      date_range: { label: "Диапазон дат" },
    },
  },
  [moduleNames.AFFILIATE_REFERRAL]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Реферал",
    columns: {
      "info.id": "ID",
      "data.username": "Имя пользователя",
      "data.first_name": "Имя",
      "data.last_name": "Фамилия",
      "data.email": "Электронная почта",
      "data.is_active": "Активен",
      "data.is_approved": "Утвержден",
    },
    filters: {
      username: {
        label: "Имя пользователя",
        description: "Поиск по имени пользователя",
      },
      email: { label: "Электронная почта" },
    },
  },
  [moduleNames.AFFILIATE_REFERRAL_STATS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Статистика рефералов",
    columns: {
      affiliate: "Партнер",
      total: "Всего",
      approved: "Одобрено",
      pending: "В ожидании",
      rejected: "Отклонено",
      banned: "Забанено",
      date: "Дата",
    },
    filters: {
      date_range: { label: "Диапазон дат" },
    },
  },

  [moduleNames.AFFILIATE_LOGIN_HISTORY]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - История входа",
    columns: {
      "info.id": "ID",
      ip: "IP",
      "info.username": "Имя пользователя",
      country_code: "Страна",
      status: "Статус",
      "data.os_type": "Устройство",
      "data.device_type": "Тип устройства",
      "data.os_title": "Название ОС",
      "data.browser_title": "Название браузера",
      "data.os_name": "Операционная система",
      "data.os_family": "Семейство ОС",
      "data.os_version": "Версия ОС",
      "data.64bits_mode": "Режим битов",
      "data.browser_name": "Браузер",
      "data.browser_version": "Версия браузера",
      "data.browser_ios_webview": "Веб-просмотр IOS браузера",
      "data.browser_desktop_mode": "Режим настольного браузера",
      "data.browser_gecko_version": "Версия Gecko браузера",
      "data.browser_webkit_version": "Версия Webkit браузера",
      "data.browser_android_webview": "Версия Android браузера",
      "data.browser_chrome_original": "Оригинальная версия Chrome браузера",
      "data.browser_safari_original": "Оригинальная версия Safari браузера",
      "data.browser_chromium_version": "Версия Chromium браузера",
      "data.browser_firefox_original": "Оригинальная версия Firefox браузера",
      "created.timestamp": "Время создания",
    },
    filters: {
      ip: { label: "IP", description: "Поиск по IP" },
    },
  },
  [moduleNames.AFFILIATE_PROFILE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    serverFieldErrors: profileServerFieldErrors,
    browserTabTitle: "MonadLead - Профиль",
    saveChanges: "Сохранить изменения",
    deleteSessionsTitle: "Удалить сеансы?",
    deleteSessionsDialog: "Вы уверены, что хотите удалить все сеансы?",
    osName: "Имя ОС",
    osTitle: "Название ОС",
    createdAt: "Дата создания",
    expires: "Истекает",
    browserName: "Имя браузера",
    deviceType: "Тип устройства",
    profileSettingsOptions: {
      general: "Общее",
      changePassword: "Изменить пароль",
      changePin: "Изменить ПИН-код",
      social: "Социальные",
      messages: "Сообщения",
      company: "Компания",
      sessions: "Сеансы",
      delete_session: "Удалить сеанс?",
      delete_confirmation: "Вы уверены, что хотите удалить этот сеанс?",
      delete: "Удалить",
      cancel: "Отмена",
    },
    helperText: {
      general: "Внесите свои общие пресональные данные",
      changePassword:
        "Если вы потеряли пароль или хотите изменить его, заполните форму ниже, написав свой новый пароль и повторив его.",
      changePin:
        "После истечения срока вашей сессии, используйте PIN-код вместо пароля для быстрого входа. Измените PIN-код, используя форму ниже.",
      social:
        "Вставьте ссылки на профили в социальных сетях, которыми вы пользуетесь в настоящее время.",
      messages:
        "Вставьте ссылки на профили в социальных сетях, которыми вы пользуетесь в настоящее время.",
      company:
        "Для регистрации вашей компании, пожалуйста, предоставьте правильную общую информацию.",
    },
    generalSettings: {
      firstName: { label: "Имя" },
      lastName: { label: "Фамилия" },
      chooseCountry: { label: "Выберите страну" },
    },
    changePasswordSettings: {
      password: { label: "Пароль" },
      repeatPassword: { label: "Повторите пароль" },
    },
    changePinSettings: {
      pin: { label: "Пин-код" },
      repeatPin: { label: "Повторите пин-код" },
    },
    socialSettings: {
      facebook: {
        label: "Ссылка на профиль Facebook",
        placeholder: "Ссылка на профиль Facebook",
      },
      google: {
        label: "Ссылка на профиль Google",
        placeholder: "Ссылка на профиль Google",
      },
      twitter: {
        label: "Ссылка на профиль Twitter",
        placeholder: "Ссылка на профиль Twitter",
      },
      linkedin: {
        label: "Ссылка на профиль Linkedin",
        placeholder: "Ссылка на профиль Linkedin",
      },
      instagram: {
        label: "Ссылка на профиль Instagram",
        placeholder: "Ссылка на профиль Instagram",
      },
    },
    messageSettings: {
      skype: { label: "Skype", placeholder: "Ссылка на профиль Skype" },
      telegram: { label: "Telegram", placeholder: "Telegram" },
      whatsapp: { label: "Whatsapp", placeholder: "Номер телефона Whatsapp" },
    },
    companySettings: {
      companyName: {
        label: "Название компании",
        placeholder: "Название компании",
      },
      country: { label: "Страна", placeholder: "Выберите страну" },
      city: { label: "Город", placeholder: "Город" },
      address: { label: "Адрес", placeholder: "Адрес" },
      zipCode: { label: "Почтовый индекс", placeholder: "Почтовый индекс" },
      companyEmail: {
        label: "Электронная почта компании",
        placeholder: "Электронная почта компании",
      },
      tax: { label: "Налог", placeholder: "Налог" },
    },
    sessions: {
      setSessionExpirationTitle: "Установить срок действия сеанса",
      expiration: {
        label: "Срок действия",
        days: {
          oneDay: "1 день",
          sevenDays: "7 дней",
          fifteenDays: "15 дней",
          thirtyDays: "30 дней",
          ninetyDays: "90 дней",
        },
      },
      activeSessionsTitle: "Активные сеансы",
      closeAllSessions: "Закрыть все сеансы",
    },
  },
  [moduleNames.AFFILIATE_FAQ]: {
    browserTabTitle: 'MonadLead - Часто задаваемые вопросы',
    title: 'Советы и ответы от команды MonadLead',
    apiSettingsTitle: 'Настройки API',
    apiSettingsSubtitle: 'Узнайте, как интегрировать вашу лендинг-страницу с MonadLead',
    postbackSettingsTitle: 'Настройки постбэка',
    postbackSettingsSubtitle: 'Поймите, как настроить постбэки для конверсий',
    introVideoTitle: 'Вводное видео',
    introVideoSubtitle: 'Посмотрите краткое введение в нашу платформу',
    videoNotSupported: 'Ваш браузер не поддерживает тег видео.',
    backToFaq: 'Назад к Часто задаваемые вопросы',
    apiSettings: {
      question1: 'Какие поля обязательны для интеграции API?',
      answer1: 'Для правильного подключения вашей лендинг-страницы к MonadLead через API обязательны следующие поля:',
      question2: 'Как подключить лендинг-страницу к MonadLead через API?',
      answer2: `Для подключения лендинг-страницы к MonadLead через API вы можете использовать шаблон файла интеграции, предоставленный вашим менеджером. Обновите файл с вашим API_KEY, настройте форму на перенаправление к этому файлу, и всё готово.`,
      question3: 'Как скачать лендинг-страницы из MonadLead?',
      answer3: 'Вы можете скачать лендинг-страницы со страницы оффера, нажав кнопку Скачать на карточке нужной лендинг-страницы.',
      question4: 'Если я скачал лендинг-страницу из MonadLead, она уже настроена?',
      answer4: 'Да. Когда вы скачиваете лендинг-страницу из MonadLead, все API-настройки уже сконфигурированы, и ваш API_KEY заполнен заранее. Всё, что нужно — разместить её на хостинге.',
    },
    postbackSettings: {
      question1: 'Какие макросы обязательны?',
      answer1: 'В MonadLead нет обязательных макросов. Вы настраиваете макросы согласно требованиям вашего трекера и вашим нуждам отслеживания.',
      question2: 'Что такое глобальный и специфический постбэк и какой выбрать?',
      answer2_1: 'Глобальный постбэк срабатывает каждый раз, когда выполняются его условия, независимо от оффера, с которого пришла конверсия.',
      answer2_2: 'Специфический постбэк привязан к конкретному офферу и срабатывает только для него.',
      answer2_3: 'Используйте специфический постбэк, если у вас особые сценарии и нужно отправлять постбэки только для одного оффера.',
      answer2_4: 'Во всех остальных случаях рекомендуется глобальный постбэк, так как он работает для всех офферов.',
    }
  },
  [moduleNames.ADVERTISER_OFFERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Офферы",
    viewLandingsLabel: "Лендинги",
    viewPrelandingsLabel: "Предлендинги",
    columns: {
      "info.id": "ID",
      "data.name": "Имя",
      "data.access": "Доступ",
      "data.status": "Статус",
      "data.paid_status": "Статус оплаты",
      "data.info.ar": "Показатель утверждения",
      "data.info.cr": "Показатель конверсии",
      "data.info.epc": "Прибыль за клик",
      "data.advertiser.id": "ID рекламодателя",
      "data.advertiser.name": "Рекламодатель",
      "data.advertiser.offer_id": "ID oфферы рекламодателя",
      "data.category.id": "Категория ",
      "data.advertiser.expected_ar": "Ожидаемый показатель утверждения",
      "data.main_country_code": "Основная страна",
      "data.advertiser.advertiser_guarantees": "Гарантии рекламодателя",
      "data.device": "Устройство",
      "data.vertical": "Вертикаль",
      "data.region": "Регион",
      "data.flow": "Flow",
      "data.charge": "Заряд",
      "data.category.name": "Название категории",
      "data.advertiser.guaranteed_ar": "Гарантированный показатель утверждения",
      "data.description": "Описание",
    },
    filters: {
      id: { label: "Имя", description: "Поиск по имени" },
      category_name: { label: "Категория", description: "Поиск по категории" },
      category_id: { label: "Категория" },
      vertical_id: { label: "Вертикаль" },
      status: { label: "Статус" },
      access: { label: "Доступ", description: "Поиск по доступу" },
      paid_status: { label: "Статус оплаты" },
      main_country_code: { label: "Основная страна" },
    },
    formData: {
      category1Vertical: { label: "Вертикаль категории 1" },
      category2Vertical: { label: "Вертикаль категории 2" },
      category3Vertical: { label: "Вертикаль категории 3" },
      category4Vertical: { label: "Вертикаль категории 4" },
      category1Flow: { label: "Flow категории 1" },
      category2Flow: { label: "Flow категории 2" },
      category3Flow: { label: "Flow категории 3" },
      category4Flow: { label: "Flow категории 4" },
    },
  },
  [moduleNames.ADVERTISER_LANDINGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Лендинги",
    moduleTitle: "Лендинги",
    columns: {
      "info.id": "ID",
      "data.name": "Имя",
      "data.download_url": "URL загрузки",
      "data.redirect_url": "URL перенаправления",
      "data.status": "Статус",
      "data.category.id": "Категория",
      "data.category.name": "Название категории",
      "data.country_code": "Страна",
      "info.offer_name": "Название oфферы",
      "info.offer_id": "ID oфферы",
      "info.country_name": "Название страны",
    },
    filters: {
      id: { label: "ID", description: "Поиск по ID" },
      status: { label: "Статус", description: "Поиск по статусу" },
      name: { label: "Имя", description: "Поиск по имени" },
    },
  },
  [moduleNames.ADVERTISER_PRELANDINGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Предлендинги",
    moduleTitle: "Предлендинги",
    columns: {
      "info.id": "ID",
      "data.name": "Имя",
      "data.download_url": "URL загрузки",
      "data.redirect_url": "URL перенаправления",
      "data.status": "Статус",
      "data.category.id": "Категория",
      "data.category.name": "Название категории",
      "data.country_code": "Страна",
      "info.offer_name": "Офферы",
      "info.offer_id": "ID oфферы",
      "info.country_name": "Название страны",
    },
    filters: {
      id: { label: "ID", description: "Поиск по ID" },
      status: { label: "Статус", description: "Поиск по статусу" },
      name: { label: "Имя", description: "Поиск по имени" },
    },
  },
  [moduleNames.ADVERTISER_DASHBOARD]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Дашборд",
    cost: "Стоимость",
    conversion: "Конверсия",
    conversion_rate: "Коэффициент конверсии",
    hold: "В холде",
    canceled: "Отменено",
    trash: "В Треше",
    statistics: "Статистика",
    rangeShortcuts: {
      today: "Сегодня",
      yesterday: "Вчера",
      thisWeek: "На этой неделе",
      lastWeek: "На прошлой неделе",
      last7Days: "Последние 7 дней",
      currentMonth: "Текущий месяц",
      lastMonth: "Прошлый месяц",
      selectDate: "Выбрать диапазон дат",
      cancelButton: "Отмена",
      clearButton: "Очистить",
      dateFrom: "Дата начала",
      dateTo: "Конец",
    },

    card: {
      today: "Сегодня",
      yesterday: "Вчера",
      currentMonth: "Текущий месяц",
      lastMonth: "Прошлый месяц",
    },
  },
  [moduleNames.ADVERTISER_ORDERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Заказы",
    columns: {
      "info.id": "ID",
      name: "Имя",
      phone: "Телефон",
      "offer.id": "ID oфферы",
      "offer.name": "Название oфферы",
      "advertiser.offer_id": "ID oфферы рекламодателя",
      "info.status": "Статус",
      "info.before_status": "Предыдущий статус",
      "flow.landings.id": "ID переходов",
      "flow.landings.name": "Название переходов",
      "flow.prelandings.id": "ID предварительных переходов",
      "flow.prelandings.name": "Название предварительных переходов",
      country_code: "Страна",
      quantity: "Количество",
      "tracking.user_ip": "IP пользователя",
      "created.timestamp": "Создан",
      base_url: "Базовый URL",
      referrer: "Referrer",
      "tracking.sub_1": "Sub 1",
      "tracking.sub_2": "Sub 2",
      "tracking.sub_3": "Sub 3",
      "tracking.sub_4": "Sub 4",
      "tracking.os_name": "Название ОС",
      "tracking.os_version": "Версия ОС",
      "tracking.browser_name": "Название браузера",
      "tracking.browser_version": "Версия браузера",
      "tracking.safe_id": "Safe ID",
      "tracking.click_id": "Click ID",
      "tracking.device_type": "Тип устройства",
      "tracking.external_id": "Внешний ID",
      "tracking.utm_term": "UTM Термин",
      "tracking.utm_medium": "UTM Средний",
      "tracking.utm_source": "UTM Источник",
      "tracking.utm_content": "UTM контент",
      "tracking.utm_campaign": "UTM кампания",
      "info.last_update": "Последнее обновление",
      "info.counter": "Счетчик",
      test_mode: "Тестовый режим",
    },
    filters: {
      name: { label: "Имя", description: "Поиск по имени" },
      country_code: { label: "Страна", description: "Поиск по стране" },
      offer_id: {
        label: "Офферы",
        description: "Поиск по ID oфферы",
      },
      prelanding_id: {
        label: "Предпосадочная страница",
        description: "Поиск по предпосадочной странице",
      },
      landing_id: {
        label: "Посадочная страница",
        description: "Поиск по посадочной странице",
      },
      sub_1: { label: "Sub 1", description: "Поиск по Sub 1" },
      sub_2: { label: "Sub 2", description: "Поиск по Sub 2" },
      sub_3: { label: "Sub 3", description: "Поиск по Sub 3" },
      sub_4: { label: "Sub 4", description: "Поиск по Sub 4" },
      tracking_click_id: {
        label: "ID отслеживания кликов",
        description: "Поиск по ID отслеживания кликов",
      },
      external_id: { label: "Внешний ID", description: "Поиск по внешнему ID" },
      phone: { label: "Телефон", description: "Поиск по телефону" },
      status: { label: "Статус", description: "Поиск по статусу" },
    },
  },
  [moduleNames.ADVERTISER_TOPUPS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Пополнения",
    columns: {
      "info.id": "ID",
      "info.username": "Имя пользователя",
      "data.orginal_amount": "Исходная сумма",
      "data.amount": "Сумма",
      "data.invoice_number": "Номер счета",
      "data.invoice_pdf": "Счет в PDF",
      "created.timestamp": "Дата создания",
      "created.date": "Создано",
      "info.advertiser_id": "ID рекламодателя",
    },
    filters: {
      invoice_number: { label: "Номер счета" },
      amount: { label: "Сумма" },
      orginal_amount: { label: "Исходная сумма" },
    },
  },
  [moduleNames.ADVERTISER_LOGIN_HISTORY]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - История входа",
    columns: {
      "info.id": "ID",
      ip: "IP",
      "info.username": "Имя пользователя",
      country_code: "Страна",
      status: "Статус",
      "data.os_type": "Устройство",
      "data.device_type": "Тип устройства",
      "data.os_title": "Название ОС",
      "data.browser_title": "Название браузера",
      "data.os_name": "Операционная система",
      "data.os_family": "Семейство ОС",
      "data.os_version": "Версия ОС",
      "data.64bits_mode": "Режим 64 бит",
      "data.browser_name": "Браузер",
      "data.browser_version": "Версия браузера",
      "data.browser_ios_webview": "Браузер IOS Webview",
      "data.browser_desktop_mode": "Режим рабочего стола браузера",
      "data.browser_gecko_version": "Версия браузера Gecko",
      "data.browser_webkit_version": "Версия браузера Webkit",
      "data.browser_android_webview": "Версия браузера Android",
      "data.browser_chrome_original": "Оригинальный браузер Chrome",
      "data.browser_safari_original": "Оригинальный браузер Safari",
      "data.browser_chromium_version": "Версия браузера Chromium",
      "data.browser_firefox_original": "Оригинальный браузер Firefox",
      "created.timestamp": "Время создания",
    },
  },
  [moduleNames.ADVERTISER_PROFILE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    serverFieldErrors: profileServerFieldErrors,
    browserTabTitle: "MonadLead - Профиль",
    saveChanges: "Сохранить изменения",
    deleteSessionsTitle: "Удалить сеансы?",
    deleteSessionsDialog: "Вы уверены, что хотите удалить все сеансы?",
    osName: "Имя ОС",
    osTitle: "Название ОС",
    createdAt: "Дата создания",
    expires: "Истекает",
    browserName: "Браузера",
    deviceType: "Тип устройства",
    profileSettingsOptions: {
      general: "Общее",
      changePassword: "Изменить пароль",
      changePin: "Изменить пин-код",
      social: "Социальные сети",
      messages: "Сообщения",
      company: "Компания",
      sessions: "Сеансы",
      delete_session: "Удалить сеанс?",
      delete_confirmation: "Вы уверены, что хотите удалить этот сеанс?",
      delete: "Удалить",
      cancel: "Отмена",
    },
    helperText: {
      general:
        "Для персонализации вашего профиля заполните общую личную информацию",
      changePassword:
        "Если вы потеряли свой пароль или хотите его изменить, заполните форму ниже, указав новый пароль и повторив его.",
      changePin:
        "После истечения срока действия вашей сессии используйте PIN-код вместо пароля для быстрого входа обратно. Измените PIN-код, используя форму ниже.",
      social:
        "Вставьте ссылки на профили в социальных сетях, которыми вы пользуетесь в данный момент.",
      messages:
        "Вставьте ссылки на профили в социальных сетях, которыми вы пользуетесь в данный момент.",
      company:
        "Для регистрации вашей компании предоставьте корректную общую информацию.",
    },
    generalSettings: {
      firstName: { label: "Имя" },
      lastName: { label: "Фамилия" },
      chooseCountry: {
        label: "Выберите страну",
        placeholder: "Выберите страну",
      },
    },
    changePasswordSettings: {
      password: { label: "Пароль" },
      repeatPassword: { label: "Повторите пароль" },
    },
    changePinSettings: {
      pin: { label: "Пин-код" },
      repeatPin: { label: "Повторите пин-код" },
    },
    socialSettings: {
      facebook: {
        label: "Ссылка на профиль в Facebook",
        placeholder: "Ссылка на профиль в Facebook",
      },
      google: {
        label: "Ссылка на профиль в Google",
        placeholder: "Ссылка на профиль в Google",
      },
      twitter: {
        label: "Ссылка на профиль в Twitter",
        placeholder: "Ссылка на профиль в Twitter",
      },
      linkedin: {
        label: "Ссылка на профиль в LinkedIn",
        placeholder: "Ссылка на профиль в LinkedIn",
      },
      instagram: {
        label: "Ссылка на профиль в Instagram",
        placeholder: "Ссылка на профиль в Instagram",
      },
    },
    messageSettings: {
      skype: { label: "Skype", placeholder: "Ссылка на профиль в Skype" },
      telegram: { label: "Telegram", placeholder: "Telegram" },
      whatsapp: { label: "WhatsApp", placeholder: "Номер телефона WhatsApp" },
    },
    companySettings: {
      companyName: {
        label: "Название компании",
        placeholder: "Название компании",
      },
      country: { label: "Страна", placeholder: "Выберите страну" },
      city: { label: "Город", placeholder: "Город" },
      address: { label: "Адрес", placeholder: "Адрес" },
      zipCode: { label: "Почтовый индекс", placeholder: "Почтовый индекс" },
      companyEmail: { label: "Email компании", placeholder: "Email компании" },
      tax: { label: "Налог", placeholder: "Налог" },
    },
    sessions: {
      setSessionExpirationTitle: "Установить срок действия сеанса",
      expiration: {
        label: "Срок действия",
        days: {
          oneDay: "1 день",
          sevenDays: "7 дней",
          fifteenDays: "15 дней",
          thirtyDays: "30 дней",
          ninetyDays: "90 дней",
        },
      },
      activeSessionsTitle: "Активные сеансы",
      closeAllSessions: "Закрыть все сеансы",
    },
  },
  [moduleNames.ADVERTISER_FAQ]: {
    browserTabTitle: 'MonadLead - Часто задаваемые вопросы',
    title: 'Советы и ответы от команды MonadLead',
    apiSettingsTitle: 'Настройки API',
    apiSettingsSubtitle: 'Узнайте, как интегрировать вашу лендинг-страницу с MonadLead',
    postbackSettingsTitle: 'Настройки постбэка',
    postbackSettingsSubtitle: 'Поймите, как настроить постбэки для конверсий',
    introVideoTitle: 'Вводное видео',
    introVideoSubtitle: 'Посмотрите краткое введение в нашу платформу',
    videoNotSupported: 'Ваш браузер не поддерживает тег видео.',
    backToFaq: 'Назад к Часто задаваемые вопросы',
    apiSettings: {
      question1: 'Какие поля обязательны для интеграции API?',
      answer1: 'Для правильного подключения вашей лендинг-страницы к MonadLead через API обязательны следующие поля:',
      question2: 'Как подключить лендинг-страницу к MonadLead через API?',
      answer2: `Для подключения лендинг-страницы к MonadLead через API вы можете использовать шаблон файла интеграции, предоставленный вашим менеджером. Обновите файл с вашим API_KEY, настройте форму на перенаправление к этому файлу, и всё готово.`,
      question3: 'Как скачать лендинг-страницы из MonadLead?',
      answer3: 'Вы можете скачать лендинг-страницы со страницы оффера, нажав кнопку Скачать на карточке нужной лендинг-страницы.',
      question4: 'Если я скачал лендинг-страницу из MonadLead, она уже настроена?',
      answer4: 'Да. Когда вы скачиваете лендинг-страницу из MonadLead, все API-настройки уже сконфигурированы, и ваш API_KEY заполнен заранее. Всё, что нужно — разместить её на хостинге.',
    },
    postbackSettings: {
      question1: 'Какие макросы обязательны?',
      answer1: 'В MonadLead нет обязательных макросов. Вы настраиваете макросы согласно требованиям вашего трекера и вашим нуждам отслеживания.',
      question2: 'Что такое глобальный и специфический постбэк и какой выбрать?',
      answer2_1: 'Глобальный постбэк срабатывает каждый раз, когда выполняются его условия, независимо от оффера, с которого пришла конверсия.',
      answer2_2: 'Специфический постбэк привязан к конкретному офферу и срабатывает только для него.',
      answer2_3: 'Используйте специфический постбэк, если у вас особые сценарии и нужно отправлять постбэки только для одного оффера.',
      answer2_4: 'Во всех остальных случаях рекомендуется глобальный постбэк, так как он работает для всех офферов.',
    },
  },
};

export default RU;
